export const CAT_FORMS: any[] = [
  {
    "fieldSets" : [ {
      "fieldSetName" : "Default",
      "fields" : [ "productCategoryId", "prodCatalogCategoryTypeId", "fromDate", "thruDate", "sequenceNum", "deleteLink", "makeTopLink", "submitButton" ]
    } ],
    "columns" : [ {
      "name" : "productCategoryId",
      "title" : "Category ID"
    }, {
      "name" : "prodCatalogCategoryTypeId",
      "title" : "Product Catalog Category Type"
    }, {
      "name" : "fromDate",
      "title" : "From Date  Time"
    }, {
      "name" : "thruDate",
      "title" : "Through Date  Time"
    }, {
      "name" : "sequenceNum",
      "title" : "Sequence Num"
    }, {
      "name" : "deleteLink",
      "title" : " "
    }, {
      "name" : "makeTopLink",
      "title" : " "
    }, {
      "name" : "submitButton",
      "title" : "Update"
    } ],
    "name" : "EditProdCatalogCategories",
    "altTarget" : [ ],
    "formLocation" : "component://product/widget/catalog/ProdCatalogForms.xml",
    "fields" : [ {
      "conditionGroup" : "",
      "name" : "prodCatalogId",
      "action" : "",
      "id" : "EditProdCatalogCategories_prodCatalogId",
      "type" : "HIDDEN",
      "event" : "",
      "value" : ""
    }, {
      "fieldHelpText" : "",
      "ajaxEnabled" : false,
      "size" : 0,
      "name" : "productCategoryId",
      "parameterList" : [{"name":"productCategoryId"}],
      "description" : "",
      "style" : "",
      "id" : "EditProdCatalogCategories_productCategoryId",
      "title" : "",
      "type" : "HYPERLINK",
      "imageLocation" : "",
      "event":"edit",
    }, {
      "fieldHelpText" : "",
      "ajaxEnabled" : false,
      "size" : 0,
      "name" : "prodCatalogCategoryTypeId",
      "description" : "",
      "style" : "",
      "id" : "EditProdCatalogCategories_prodCatalogCategoryTypeId",
      "title" : "",
      "type" : "DISPLAY_ENTITY",
      "imageLocation" : ""
    }, {
      "fieldHelpText" : "",
      "ajaxEnabled" : false,
      "size" : 0,
      "name" : "fromDate",
      "description" : "",
      "style" : "",
      "id" : "EditProdCatalogCategories_fromDate",
      "title" : "",
      "type" : "DISPLAY",
      "imageLocation" : ""
    }, {
      "classString" : "",
      "shortDateInput" : "false",
      "ampmName" : "",
      "className" : "",
      "title" : "Through Date  Time",
      "type" : "DATE_TIME",
      "dateType" : "timestamp",
      "defaultDateTimeString" : "2023-01-14%2005:41:58.738",
      "timeDropdown" : "",
      "alert" : "false",
      "timeValues" : "",
      "formName" : "EditProdCatalogCategories",
      "timeDropdownParamName" : "thruDate",
      "timeMinutesName" : "",
      "disabled" : "false",
      "id" : "EditProdCatalogCategories_thruDate",
      "event" : "",
      "value" : "",
      "pmSelected" : "",
      "localizedInputTitle" : "Format: yyyy-MM-dd HH:mm:ss.SSS",
      "mask" : "",
      "hour1" : "0",
      "isTwelveHour" : "false",
      "fieldHelpText" : "",
      "hour2" : "0",
      "maxlength" : "30",
      "minutes" : "0",
      "tabindex" : "",
      "amSelected" : "",
      "size" : "25",
      "isXMLHttpRequest" : "false",
      "localizedIconTitle" : "View Calendar",
      "timeHourName" : "",
      "name" : "thruDate",
      "style" : "",
      "step" : "1",
      "compositeType" : ""
    }, {
      "" : "",
      "fieldHelpText" : "",
      "textSize" : "6",
      "ajaxUrl" : "",
      "maxlength" : "",
      "tabindex" : "",
      "className" : "",
      "title" : "Sequence Num",
      "type" : "TEXT",
      "clientAutocomplete" : "true",
      "ajaxEnabled" : true,
      "readonly" : false,
      "alert" : "false",
      "name" : "sequenceNum",
      "action" : "",
      "style" : "",
      "disabled" : false,
      "id" : "EditProdCatalogCategories_sequenceNum",
      "placeholder" : "",
      "event" : "",
      "value" : "",
      "mask" : ""
    }, {
      "image" : "",
      "width" : "",
      "name" : "deleteLink",
      "alternate" : "",
      "description" : "Delete",
      "parameterList" : [ {
        "name" : "prodCatalogId"
      }, {
        "name" : "productCategoryId"
      }, {
        "name" : "partyId"
      }, {
        "name" : "fromDate"
      }, {
        "name" : "prodCatalogCategoryTypeId"
      } ],
      "id" : "EditProdCatalogCategories_deleteLink",
      "imageTitle" : "",
      "parameterMap" : { },
      "height" : ""
    }, {
      "image" : "",
      "width" : "",
      "name" : "makeTopLink",
      "alternate" : "",
      "description" : "MakeTop",
      "parameterList" : [ {
        "fromField" : {
          "isEmpty" : false,
          "original" : "productCategoryId",
          "bracketedOriginal" : "${productCategoryId}",
          "isAscending" : true,
          "empty" : false,
          "originalName" : "productCategoryId"
        },
        "name" : "CATALOG_TOP_CATEGORY"
      }, {
        "name" : "productCategoryId"
      } ],
      "id" : "EditProdCatalogCategories_makeTopLink",
      "imageTitle" : "",
      "parameterMap" : { },
      "height" : ""
    }, {
      "buttonType" : "button",
      "alert" : "false",
      "formName" : "EditProdCatalogCategories",
      "tabindex" : "",
      "name" : "submitButton",
      "className" : "smallSubmit",
      "id" : "EditProdCatalogCategories_submitButton",
      "confirmation" : "",
      "type" : "SUBMIT",
      "title" : "Update",
      "event" : "",
      "imgSrc" : ""
    } ],
    "target" : "updateProductCategoryToProdCatalog"
  },
  {
    "fieldSets" : [ {
      "fieldSetName" : "Default",
      "fields" : [ "productId", "fromDate", "thruDate", "comments", "sequenceNum", "quantity", "smallImageUrl", "deleteLink", "submitButton" ]
    } ],
    "columns" : [ {
      "name" : "productId",
      "title" : "Product Name ID"
    }, {
      "name" : "fromDate",
      "title" : "From Date"
    }, {
      "name" : "thruDate",
      "title" : "Through Date"
    }, {
      "name" : "comments",
      "title" : "Comments"
    }, {
      "name" : "sequenceNum",
      "title" : "Sequence"
    }, {
      "name" : "quantity",
      "title" : "Quantity"
    }, {
      "name" : "smallImageUrl",
      "title" : "Image"
    }, {
      "name" : "deleteLink",
      "title" : " "
    }, {
      "name" : "submitButton",
      "title" : "Update"
    } ],
    "formName" : "EditCategoryProducts",
    "altTarget" : [ ],
    "formLocation" : "component://kwikstore/widget/KwikstoreForms.xml",
    "fields" : [ {
      "conditionGroup" : "",
      "name" : "productCategoryId",
      "action" : "",
      "id" : "EditCategoryProducts_productCategoryId",
      "type" : "HIDDEN",
      "event" : "",
      "value" : "100"
    }, {
      "hyperlink" : {
        "linkStyle" : "buttontext",
        "description" : "[]",
        "targetType" : "intra-app",
        "confirmation" : "",
        "parameterMap" : {
          "VIEW_SIZE_0" : "20",
          "VIEW_INDEX_0" : "0"
        },
        "uniqueItemName" : "Modal_33f1b4e7_480c_437d_ab5d_c227b3ecb4c5",
        "target" : "EditProductRest",
        "targetWindow" : "",
        "remoteFormData":{
          "formData":{
            "formName":"EditProductRest",
            "formLocation":"component://kwikstore/widget/ProductForms.xml"
          }
        }
      },
      "event":"edit",
      "fieldHelpText" : "",
      "ajaxEnabled" : false,
      "size" : 0,
      "name" : "productId",
      "description" : "",
      "style" : "",
      "id" : "EditCategoryProducts_productId",
      "title" : "",
      "type" : "DISPLAY_ENTITY",
      "imageLocation" : ""
    }, {
      "fieldHelpText" : "",
      "ajaxEnabled" : false,
      "size" : 0,
      "name" : "fromDate",
      "description" : "",
      "style" : "",
      "id" : "EditCategoryProducts_fromDate",
      "title" : "",
      "type" : "DISPLAY",
      "imageLocation" : ""
    }, {
      "classString" : "",
      "shortDateInput" : "false",
      "ampmName" : "",
      "className" : "",
      "title" : "Through Date",
      "type" : "DATE_TIME",
      "dateType" : "timestamp",
      "defaultDateTimeString" : "2023-02-06%2011:59:42.769",
      "timeDropdown" : "",
      "alert" : "false",
      "timeValues" : "",
      "formName" : "EditCategoryProducts",
      "timeDropdownParamName" : "thruDate",
      "timeMinutesName" : "",
      "disabled" : "false",
      "id" : "EditCategoryProducts_thruDate",
      "event" : "",
      "value" : "",
      "pmSelected" : "",
      "localizedInputTitle" : "Format: yyyy-MM-dd HH:mm:ss.SSS",
      "mask" : "",
      "hour1" : "0",
      "isTwelveHour" : "false",
      "fieldHelpText" : "",
      "hour2" : "0",
      "maxlength" : "30",
      "minutes" : "0",
      "tabindex" : "",
      "amSelected" : "",
      "size" : "25",
      "isXMLHttpRequest" : "false",
      "localizedIconTitle" : "View Calendar",
      "timeHourName" : "",
      "name" : "thruDate",
      "style" : "",
      "step" : "1",
      "compositeType" : ""
    }, {
      "" : "",
      "fieldHelpText" : "",
      "textSize" : "60",
      "ajaxUrl" : "",
      "maxlength" : "250",
      "tabindex" : "",
      "className" : "",
      "title" : "Comments",
      "type" : "TEXT",
      "clientAutocomplete" : "true",
      "ajaxEnabled" : true,
      "readonly" : false,
      "alert" : "false",
      "name" : "comments",
      "action" : "",
      "style" : "",
      "disabled" : false,
      "id" : "EditCategoryProducts_comments",
      "placeholder" : "",
      "event" : "",
      "value" : "",
      "mask" : ""
    }, {
      "" : "",
      "fieldHelpText" : "",
      "textSize" : "6",
      "ajaxUrl" : "",
      "maxlength" : "",
      "tabindex" : "",
      "className" : "",
      "title" : "Sequence",
      "type" : "TEXT",
      "clientAutocomplete" : "true",
      "ajaxEnabled" : true,
      "readonly" : false,
      "alert" : "false",
      "name" : "sequenceNum",
      "action" : "",
      "style" : "",
      "disabled" : false,
      "id" : "EditCategoryProducts_sequenceNum",
      "placeholder" : "",
      "event" : "",
      "value" : "",
      "mask" : ""
    }, {
      "" : "",
      "fieldHelpText" : "",
      "textSize" : "6",
      "ajaxUrl" : "",
      "maxlength" : "",
      "tabindex" : "",
      "className" : "",
      "title" : "Quantity",
      "type" : "TEXT",
      "clientAutocomplete" : "true",
      "ajaxEnabled" : true,
      "readonly" : false,
      "alert" : "false",
      "name" : "quantity",
      "action" : "",
      "style" : "",
      "disabled" : false,
      "id" : "EditCategoryProducts_quantity",
      "placeholder" : "",
      "event" : "",
      "value" : "",
      "mask" : ""
    }, {
      "fieldHelpText" : "",
      "ajaxEnabled" : false,
      "size" : 0,
      "name" : "smallImageUrl",
      "description" : "",
      "style" : "",
      "id" : "EditCategoryProducts_smallImageUrl",
      "title" : "",
      "type" : "DISPLAY",
      "imageLocation" : ""
    }, {
      "image" : "",
      "width" : "",
      "name" : "deleteLink",
      "alternate" : "",
      "description" : "Delete",
      "parameterList" : [ {
        "name" : "productId"
      }, {
        "name" : "productCategoryId"
      }, {
        "name" : "fromDate"
      } ],
      "id" : "EditCategoryProducts_deleteLink",
      "imageTitle" : "",
      "parameterMap" : {
        "productCategoryId" : "100"
      },
      "height" : ""
    }, {
      "buttonType" : "button",
      "alert" : "false",
      "formName" : "EditCategoryProducts",
      "tabindex" : "",
      "name" : "submitButton",
      "className" : "smallSubmit",
      "id" : "EditCategoryProducts_submitButton",
      "confirmation" : "",
      "type" : "SUBMIT",
      "title" : "Update",
      "event" : "",
      "imgSrc" : ""
    } ],
    "target" : "updateCategoryProductMember"
  },
  {
    "fieldSets" : [ {
      "fieldSetName" : "Default",
      "fields" : [ "productId", "fromDate", "thruDate", "comments", "sequenceNum", "quantity", "activeOnly", "submitButton" ]
    } ],
    "formName" : "AddProductCategoryMember",
    "altTarget" : [ ],
    "formLocation" : "component://kwikstore/widget/KwikstoreForms.xml",
    "fields" : [ {
      "conditionGroup" : "",
      "name" : "productCategoryId",
      "action" : "",
      "id" : "AddProductCategoryMember_productCategoryId",
      "type" : "HIDDEN",
      "event" : "",
      "value" : "100"
    }, {
      "conditionGroup" : "",
      "name" : "activeOnly",
      "action" : "",
      "id" : "AddProductCategoryMember_activeOnly",
      "type" : "HIDDEN",
      "event" : "",
      "value" : "true"
    }, {
      "fieldHelpText" : "",
      "lookupOptions" : {
        "ajaxUrl" : "",
        "fadeBackground" : "true",
        "conditionGroup" : "",
        "targetParameterList" : [ "" ],
        "className" : "",
        "type" : "LOOKUP",
        "presentation" : "layer",
        "initiallyCollapsed" : "false",
        "ajaxEnabled" : "true",
        "showDescription" : "true",
        "delegatorName" : "",
        "readonly" : "false",
        "alert" : "false",
        "formName" : "AddProductCategoryMember",
        "id" : "AddProductCategoryMember_productId",
        "event" : "",
        "value" : "",
        "fieldFormName" : "LookupProductCategory",
        "maxlength" : "",
        "autocomplete" : "",
        "clearText" : "Clear",
        "tabindex" : "",
        "size" : "25",
        "name" : "productId",
        "descriptionFieldName" : "",
        "position" : "topleft",
        "imgSrc" : ""
      },
      "name" : "productId",
      "style" : "",
      "id" : "AddProductCategoryMember_productId",
      "title" : "Product ID",
      "type" : "LOOKUP"
    }, {
      "classString" : "",
      "shortDateInput" : "false",
      "ampmName" : "",
      "className" : "",
      "title" : "From Date  Time",
      "type" : "DATE_TIME",
      "dateType" : "timestamp",
      "defaultDateTimeString" : "2023-02-06%2013:24:55.222",
      "timeDropdown" : "",
      "alert" : "false",
      "timeValues" : "",
      "formName" : "AddProductCategoryMember",
      "timeDropdownParamName" : "fromDate",
      "timeMinutesName" : "",
      "disabled" : "false",
      "id" : "AddProductCategoryMember_fromDate",
      "event" : "",
      "value" : "",
      "pmSelected" : "",
      "localizedInputTitle" : "Format: yyyy-MM-dd HH:mm:ss.SSS",
      "mask" : "",
      "hour1" : "0",
      "isTwelveHour" : "false",
      "fieldHelpText" : "",
      "hour2" : "0",
      "maxlength" : "30",
      "minutes" : "0",
      "tabindex" : "",
      "amSelected" : "",
      "size" : "25",
      "isXMLHttpRequest" : "false",
      "localizedIconTitle" : "View Calendar",
      "timeHourName" : "",
      "name" : "fromDate",
      "style" : "",
      "step" : "1",
      "compositeType" : ""
    }, {
      "classString" : "",
      "shortDateInput" : "false",
      "ampmName" : "",
      "className" : "",
      "title" : "Through Date",
      "type" : "DATE_TIME",
      "dateType" : "timestamp",
      "defaultDateTimeString" : "2023-02-06%2013:24:55.222",
      "timeDropdown" : "",
      "alert" : "false",
      "timeValues" : "",
      "formName" : "AddProductCategoryMember",
      "timeDropdownParamName" : "thruDate",
      "timeMinutesName" : "",
      "disabled" : "false",
      "id" : "AddProductCategoryMember_thruDate",
      "event" : "",
      "value" : "",
      "pmSelected" : "",
      "localizedInputTitle" : "Format: yyyy-MM-dd HH:mm:ss.SSS",
      "mask" : "",
      "hour1" : "0",
      "isTwelveHour" : "false",
      "fieldHelpText" : "",
      "hour2" : "0",
      "maxlength" : "30",
      "minutes" : "0",
      "tabindex" : "",
      "amSelected" : "",
      "size" : "25",
      "isXMLHttpRequest" : "false",
      "localizedIconTitle" : "View Calendar",
      "timeHourName" : "",
      "name" : "thruDate",
      "style" : "",
      "step" : "1",
      "compositeType" : ""
    }, {
      "" : "",
      "fieldHelpText" : "",
      "textSize" : "60",
      "ajaxUrl" : "",
      "maxlength" : "250",
      "tabindex" : "",
      "className" : "",
      "title" : "Comments",
      "type" : "TEXT",
      "clientAutocomplete" : "true",
      "ajaxEnabled" : true,
      "readonly" : false,
      "alert" : "false",
      "name" : "comments",
      "action" : "",
      "style" : "",
      "disabled" : false,
      "id" : "AddProductCategoryMember_comments",
      "placeholder" : "",
      "event" : "",
      "value" : "",
      "mask" : ""
    }, {
      "" : "",
      "fieldHelpText" : "",
      "textSize" : "6",
      "ajaxUrl" : "",
      "maxlength" : "",
      "tabindex" : "",
      "className" : "",
      "title" : "Sequence Num",
      "type" : "TEXT",
      "clientAutocomplete" : "true",
      "ajaxEnabled" : true,
      "readonly" : false,
      "alert" : "false",
      "name" : "sequenceNum",
      "action" : "",
      "style" : "",
      "disabled" : false,
      "id" : "AddProductCategoryMember_sequenceNum",
      "placeholder" : "",
      "event" : "",
      "value" : "",
      "mask" : ""
    }, {
      "" : "",
      "fieldHelpText" : "",
      "textSize" : "6",
      "ajaxUrl" : "",
      "maxlength" : "",
      "tabindex" : "",
      "className" : "",
      "title" : "Quantity",
      "type" : "TEXT",
      "clientAutocomplete" : "true",
      "ajaxEnabled" : true,
      "readonly" : false,
      "alert" : "false",
      "name" : "quantity",
      "action" : "",
      "style" : "",
      "disabled" : false,
      "id" : "AddProductCategoryMember_quantity",
      "placeholder" : "",
      "event" : "",
      "value" : "",
      "mask" : ""
    }, {
      "buttonType" : "button",
      "alert" : "false",
      "formName" : "AddProductCategoryMember",
      "tabindex" : "",
      "name" : "submitButton",
      "className" : "smallSubmit",
      "id" : "AddProductCategoryMember_submitButton",
      "confirmation" : "",
      "type" : "SUBMIT",
      "title" : "Add",
      "event" : "",
      "imgSrc" : ""
    } ],
    "target" : "addCategoryProductMember"
  },
    {
        "statusCode" : 200,
        "statusDescription" : "OK",
        "successMessage" : "OK",
        "data" : {
          "formData" : {
            "formName" : "FindCategory",
            "altTarget" : [ ],
            "formLocation" : "component://product/widget/catalog/CategoryForms.xml",
            "fields" : [ {
              "conditionGroup" : "",
              "name" : "noConditionFind",
              "action" : "",
              "id" : "FindCategory_noConditionFind",
              "type" : "HIDDEN",
              "event" : "",
              "value" : "Y"
            }, {
              "maxlength" : "",
              "autocomplete" : "",
              "tabindex" : "",
              "conditionGroup" : "",
              "defaultOption" : "contains",
              "opEquals" : "Equals",
              "opNotEqual" : "Not Equal",
              "className" : "",
              "type" : "TEXTQBE",
              "opBeginsWith" : "Begins With",
              "opContains" : "Contains",
              "opIsEmpty" : "Is Empty",
              "size" : "25",
              "alert" : "false",
              "ignoreCase" : "Ignore Case",
              "name" : "productCategoryId",
              "hideIgnoreCase" : "false",
              "titleStyle" : "",
              "value" : "",
              "ignCase" : "true"
            }, {
              "maxlength" : "",
              "autocomplete" : "",
              "tabindex" : "",
              "conditionGroup" : "",
              "defaultOption" : "contains",
              "opEquals" : "Equals",
              "opNotEqual" : "Not Equal",
              "className" : "",
              "type" : "TEXTQBE",
              "opBeginsWith" : "Begins With",
              "opContains" : "Contains",
              "opIsEmpty" : "Is Empty",
              "size" : "25",
              "alert" : "false",
              "ignoreCase" : "Ignore Case",
              "name" : "categoryName",
              "hideIgnoreCase" : "false",
              "titleStyle" : "",
              "value" : "",
              "ignCase" : "true"
            }, {
              "buttonType" : "button",
              "alert" : "false",
              "formName" : "FindCategory",
              "tabindex" : "",
              "name" : "submitButton",
              "className" : "smallSubmit",
              "id" : "FindCategory_submitButton",
              "confirmation" : "",
              "type" : "SUBMIT",
              "title" : "",
              "event" : "",
              "imgSrc" : ""
            } ],
            "target" : "FindCategory"
          },
          "responseMessage" : "success"
        }
      },
      {
        "statusCode" : 200,
        "statusDescription" : "OK",
        "successMessage" : "OK",
        "data" : {
          "formData" : {
            "columns" : [ {
              "name" : "productCategoryId",
              "title" : "Product Category ID"
            }, {
              "name" : "productCategoryTypeId",
              "title" : "Product Category Type ID"
            }, {
              "name" : "primaryParentCategoryId",
              "title" : "Primary Parent Category ID"
            }, {
              "name" : "categoryName",
              "title" : "Category Name"
            }, {
              "name" : "description",
              "title" : "Description"
            } ],
            "formName" : "ListCategory",
            "altTarget" : [ ],
            "formLocation" : "component://product/widget/catalog/CategoryForms.xml",
            "fields" : [ {
              "image" : "",
              "fieldHelpText" : "",
              "alternate" : "",
              "description" : "",
              "type" : "HYPERLINK",
              "isSortField" : "Y",
              "width" : "",
              "name" : "productCategoryId",
              "parameterList" : [ {
                "name" : "productCategoryId"
              } ],
              "style" : "",
              "id" : "ListCategory_productCategoryId",
              "imageTitle" : "",
              "parameterMap" : { },
              "height" : ""
            }, {
              "fieldHelpText" : "",
              "ajaxEnabled" : false,
              "isSortField" : "Y",
              "size" : 0,
              "name" : "productCategoryTypeId",
              "description" : "",
              "style" : "",
              "id" : "ListCategory_productCategoryTypeId",
              "type" : "DISPLAY_ENTITY",
              "title" : "",
              "imageLocation" : ""
            }, {
              "fieldHelpText" : "",
              "ajaxEnabled" : false,
              "isSortField" : "Y",
              "size" : 0,
              "name" : "primaryParentCategoryId",
              "description" : "",
              "style" : "",
              "id" : "ListCategory_primaryParentCategoryId",
              "type" : "DISPLAY",
              "title" : "",
              "imageLocation" : ""
            }, {
              "fieldHelpText" : "",
              "ajaxEnabled" : false,
              "isSortField" : "Y",
              "size" : 0,
              "name" : "categoryName",
              "description" : "",
              "style" : "",
              "id" : "ListCategory_categoryName",
              "type" : "DISPLAY",
              "title" : "",
              "imageLocation" : ""
            }, {
              "fieldHelpText" : "",
              "ajaxEnabled" : false,
              "isSortField" : "Y",
              "size" : 0,
              "name" : "description",
              "description" : "",
              "style" : "",
              "id" : "ListCategory_description",
              "type" : "DISPLAY",
              "title" : "",
              "imageLocation" : ""
            } ],
            "target" : ""
          },
          "responseMessage" : "success"
        }
      },
      {
        "fieldSets" : [ {
          "fieldSetName" : "Default",
          "fields" : [ "productCategoryId", "productCategoryId", "productCategoryTypeId", "primaryParentCategoryId", "categoryName", "description", "longDescription", "categoryImageUrl", "linkOneImageUrl", "linkTwoImageUrl", "detailScreen", "showInSelect", "submitButton" ]
        } ],
        "formName" : "EditCategory",
        "targets":{
          createTarget:"createProductCategory",
          updateTarget:"updateProductCategory"
        },
        "altTarget" : [ {
          "useWhen" : "productCatyegoryId==null",
          "targetExdr" : {
            "chars" : "createProductCategory",
            "hint" : 20,
            "empty" : false,
            "original" : "createProductCategory"
          }
        } ],
        "formLocation" : "component://kwikstore/widget/CategoryForms.xml",
        "titleDescriptionField":"categoryName",
        "idFieldName":"productCategoryId",
        "fields" : [ {
          "" : "",
          "fieldHelpText" : "",
          "textSize" : "20",
          "ajaxUrl" : "",
          "maxlength" : "20",
          "tabindex" : "",
          "className" : "",
          "title" : "Category ID",
          "type" : "TEXT",
          "clientAutocomplete" : "true",
          "ajaxEnabled" : true,
          "readonly" : false,
          "alert" : "false",
          "name" : "productCategoryId",
          "action" : "",
          "style" : "",
          "disabled" : false,
          "id" : "EditCategory_productCategoryId",
          "placeholder" : "",
          "event" : "",
          "value" : "",
          "mask" : ""
        }, {
          "fieldName" : "",
          "firstInList" : "",
          "partialChars" : "",
          "conditionGroup" : "",
          "otherFieldName" : "",
          "className" : "",
          "title" : "Product Category Type Id",
          "type" : "DROP_DOWN",
          "frequency" : "",
          "minChars" : "",
          "allowEmpty" : "",
          "autoSelect" : "",
          "ajaxEnabled" : "false",
          "noCurrentSelectedKey" : "",
          "ajaxOptions" : "",
          "alert" : "false",
          "otherFieldSize" : "0",
          "ignoreCase" : "",
          "formName" : "EditCategory",
          "options" : [ {
            "description" : "Best Selling",
            "key" : "BEST_SELL_CATEGORY"
          }, {
            "description" : "Catalog",
            "key" : "CATALOG_CATEGORY"
          }, {
            "description" : "Cross Sell",
            "key" : "CROSS_SELL_CATEGORY"
          }, {
            "description" : "Gift Cards",
            "key" : "GIFT_CARD_CATEGORY"
          }, {
            "description" : "Google Base",
            "key" : "GOOGLE_BASE_CATEGORY"
          }, {
            "description" : "Industry",
            "key" : "INDUSTRY_CATEGORY"
          }, {
            "description" : "Internal",
            "key" : "INTERNAL_CATEGORY"
          }, {
            "description" : "Materials",
            "key" : "MATERIALS_CATEGORY"
          }, {
            "description" : "Mix and Match",
            "key" : "MIXMATCH_CATEGORY"
          }, {
            "description" : "Quick Add",
            "key" : "QUICKADD_CATEGORY"
          }, {
            "description" : "Search",
            "key" : "SEARCH_CATEGORY"
          }, {
            "description" : "Tax",
            "key" : "TAX_CATEGORY"
          }, {
            "description" : "Usage",
            "key" : "USAGE_CATEGORY"
          }, {
            "description" : "eBay",
            "key" : "EBAY_CATEGORY"
          } ],
          "disabled" : "false",
          "id" : "EditCategory_productCategoryTypeId",
          "event" : "",
          "otherValue" : "",
          "fullSearch" : "",
          "fieldHelpText" : "",
          "dDFCurrent" : "selected",
          "tabindex" : "",
          "multiple" : "",
          "partialSearch" : "",
          "size" : "1",
          "name" : "productCategoryTypeId",
          "style" : "",
          "explicitDescription" : "",
          "choices" : "",
          "currentValue" : ""
        }, {
          "fieldHelpText" : "",
          "lookupOptions" : {
            "ajaxUrl" : "",
            "fadeBackground" : "true",
            "conditionGroup" : "",
            "targetParameterList" : [ "" ],
            "className" : "",
            "type" : "LOOKUP",
            "presentation" : "layer",
            "initiallyCollapsed" : "false",
            "ajaxEnabled" : "true",
            "showDescription" : "true",
            "delegatorName" : "",
            "readonly" : "false",
            "alert" : "false",
            "formName" : "EditCategory",
            "id" : "EditCategory_primaryParentCategoryId",
            "event" : "",
            "value" : "",
            "fieldFormName" : "productCategoryForm",
            "maxlength" : "",
            "autocomplete" : "",
            "clearText" : "Clear",
            "tabindex" : "",
            "size" : "25",
            "name" : "primaryParentCategoryId",
            "descriptionFieldName" : "",
            "position" : "topleft",
            "imgSrc" : ""
          },
          "name" : "primaryParentCategoryId",
          "style" : "",
          "id" : "EditCategory_primaryParentCategoryId",
          "title" : "Primary Parent Category",
          "type" : "LOOKUP"
        }, {
          "" : "",
          "fieldHelpText" : "",
          "textSize" : "25",
          "ajaxUrl" : "",
          "maxlength" : "",
          "tabindex" : "",
          "className" : "",
          "title" : "Category Name",
          "type" : "TEXT",
          "clientAutocomplete" : "true",
          "ajaxEnabled" : true,
          "readonly" : false,
          "alert" : "false",
          "name" : "categoryName",
          "action" : "",
          "style" : "",
          "disabled" : false,
          "id" : "EditCategory_categoryName",
          "placeholder" : "",
          "event" : "",
          "value" : "",
          "mask" : ""
        }, {
          "fieldHelpText" : "",
          "buttons" : "",
          "maxlength" : "",
          "tabindex" : "",
          "className" : "",
          "language" : "en",
          "title" : "Product Category Description",
          "type" : "TEXTAREA",
          "rows" : "3",
          "readonly" : "",
          "visualEditorEnable" : "",
          "alert" : "false",
          "name" : "description",
          "style" : "",
          "disabled" : "false",
          "id" : "EditCategory_description",
          "value" : "",
          "cols" : "60"
        }, {
          "fieldHelpText" : "",
          "buttons" : "",
          "maxlength" : "",
          "tabindex" : "",
          "className" : "",
          "language" : "en",
          "title" : "Long Description",
          "type" : "TEXTAREA",
          "rows" : "2",
          "readonly" : "",
          "visualEditorEnable" : "",
          "alert" : "false",
          "name" : "longDescription",
          "style" : "",
          "disabled" : "false",
          "id" : "EditCategory_longDescription",
          "value" : "",
          "cols" : "60"
        }, {
          "" : "",
          "fieldHelpText" : "",
          "textSize" : "25",
          "ajaxUrl" : "",
          "maxlength" : "",
          "tabindex" : "",
          "className" : "",
          "title" : "Category Image Url",
          "type" : "TEXT",
          "clientAutocomplete" : "true",
          "ajaxEnabled" : true,
          "readonly" : false,
          "alert" : "false",
          "name" : "categoryImageUrl",
          "action" : "",
          "style" : "",
          "disabled" : false,
          "id" : "EditCategory_categoryImageUrl",
          "placeholder" : "",
          "event" : "",
          "value" : "",
          "mask" : ""
        }, {
          "" : "",
          "fieldHelpText" : "",
          "textSize" : "25",
          "ajaxUrl" : "",
          "maxlength" : "",
          "tabindex" : "",
          "className" : "",
          "title" : "Link One Image Url",
          "type" : "TEXT",
          "clientAutocomplete" : "true",
          "ajaxEnabled" : true,
          "readonly" : false,
          "alert" : "false",
          "name" : "linkOneImageUrl",
          "action" : "",
          "style" : "",
          "disabled" : false,
          "id" : "EditCategory_linkOneImageUrl",
          "placeholder" : "",
          "event" : "",
          "value" : "",
          "mask" : ""
        }, {
          "" : "",
          "fieldHelpText" : "",
          "textSize" : "25",
          "ajaxUrl" : "",
          "maxlength" : "",
          "tabindex" : "",
          "className" : "",
          "title" : "Link Two Image Url",
          "type" : "TEXT",
          "clientAutocomplete" : "true",
          "ajaxEnabled" : true,
          "readonly" : false,
          "alert" : "false",
          "name" : "linkTwoImageUrl",
          "action" : "",
          "style" : "",
          "disabled" : false,
          "id" : "EditCategory_linkTwoImageUrl",
          "placeholder" : "",
          "event" : "",
          "value" : "",
          "mask" : ""
        }, {
          "" : "",
          "fieldHelpText" : "",
          "textSize" : "25",
          "ajaxUrl" : "",
          "maxlength" : "",
          "tabindex" : "",
          "className" : "",
          "title" : "Detail Screen",
          "type" : "TEXT",
          "clientAutocomplete" : "true",
          "ajaxEnabled" : true,
          "readonly" : false,
          "alert" : "false",
          "name" : "detailScreen",
          "action" : "",
          "style" : "",
          "disabled" : false,
          "id" : "EditCategory_detailScreen",
          "placeholder" : "",
          "event" : "",
          "value" : "",
          "mask" : ""
        }, {
          "fieldName" : "",
          "firstInList" : "",
          "partialChars" : "",
          "conditionGroup" : "",
          "otherFieldName" : "",
          "className" : "",
          "title" : "Show In Select",
          "type" : "DROP_DOWN",
          "frequency" : "",
          "minChars" : "",
          "allowEmpty" : "",
          "autoSelect" : "",
          "ajaxEnabled" : "false",
          "noCurrentSelectedKey" : "",
          "ajaxOptions" : "",
          "alert" : "false",
          "otherFieldSize" : "0",
          "ignoreCase" : "",
          "formName" : "EditCategory",
          "options" : [ {
            "description" : "Y",
            "key" : "Y"
          }, {
            "description" : "N",
            "key" : "N"
          } ],
          "disabled" : "false",
          "id" : "EditCategory_showInSelect",
          "event" : "",
          "otherValue" : "",
          "fullSearch" : "",
          "fieldHelpText" : "",
          "dDFCurrent" : "first-in-list",
          "tabindex" : "",
          "multiple" : "",
          "partialSearch" : "",
          "size" : "1",
          "name" : "showInSelect",
          "style" : "",
          "explicitDescription" : "",
          "choices" : "",
          "currentValue" : ""
        }, {
          "buttonType" : "button",
          "alert" : "false",
          "formName" : "EditCategory",
          "tabindex" : "",
          "name" : "submitButton",
          "className" : "smallSubmit",
          "id" : "EditCategory_submitButton",
          "confirmation" : "",
          "type" : "SUBMIT",
          "title" : "Update",
          "event" : "",
          "imgSrc" : ""
        } ],
        "target" : "updateProductCategory"
      },
      {
        "statusCode" : 200,
        "statusDescription" : "OK",
        "successMessage" : "OK",
        "data" : {
          "formData" : {
            "formName" : "ProductCategoryUploadImage",
            "altTarget" : [ ],
            "formLocation" : "component://kwikstore/widget/CategoryForms.xml",
            "fields" : [ {
              "conditionGroup" : "",
              "name" : "productCategoryId",
              "action" : "",
              "id" : "ProductCategoryUploadImage_productCategoryId",
              "type" : "HIDDEN",
              "event" : "",
              "value" : ""
            }, {
              "fieldHelpText" : "",
              "maxlength" : "",
              "autocomplete" : "",
              "tabindex" : "",
              "className" : "",
              "title" : "Fname",
              "type" : "FILE",
              "size" : "50",
              "alert" : "false",
              "name" : "fname",
              "style" : "",
              "id" : "ProductCategoryUploadImage_fname",
              "value" : ""
            }, {
              "fieldHelpText" : "",
              "name" : "upload_file_type",
              "style" : "",
              "id" : "ProductCategoryUploadImage_upload_file_type",
              "title" : "Upload_file_type",
              "type" : "RADIO"
            }, {
              "buttonType" : "button",
              "alert" : "false",
              "formName" : "ProductCategoryUploadImage",
              "tabindex" : "",
              "name" : "submitButton",
              "className" : "smallSubmit",
              "id" : "ProductCategoryUploadImage_submitButton",
              "confirmation" : "",
              "type" : "SUBMIT",
              "title" : "",
              "event" : "",
              "imgSrc" : ""
            } ],
            "target" : "UploadCategoryImage"
          },
          "responseMessage" : "success"
        }
      },
      {
        "statusCode" : 200,
        "statusDescription" : "OK",
        "successMessage" : "OK",
        "data" : {
          "formData" : {
            "formName" : "DuplicateProductCategory",
            "altTarget" : [ ],
            "formLocation" : "component://kwikstore/widget/CategoryForms.xml",
            "fields" : [ {
              "conditionGroup" : "",
              "name" : "oldProductCategoryId",
              "action" : "",
              "id" : "DuplicateProductCategory_oldProductCategoryId",
              "type" : "HIDDEN",
              "event" : "",
              "value" : ""
            }, {
              "" : "",
              "fieldHelpText" : "",
              "textSize" : "25",
              "ajaxUrl" : "",
              "maxlength" : "",
              "tabindex" : "",
              "className" : "",
              "title" : "Product Category ID",
              "type" : "TEXT",
              "clientAutocomplete" : "true",
              "ajaxEnabled" : true,
              "readonly" : false,
              "alert" : "false",
              "name" : "productCategoryId",
              "action" : "",
              "style" : "",
              "disabled" : false,
              "id" : "DuplicateProductCategory_productCategoryId",
              "placeholder" : "",
              "event" : "",
              "value" : "",
              "mask" : ""
            }, {
              "fieldHelpText" : "",
              "name" : "duplicateContent",
              "style" : "",
              "id" : "DuplicateProductCategory_duplicateContent",
              "title" : "Content",
              "type" : "CHECK"
            }, {
              "fieldHelpText" : "",
              "name" : "duplicateParentRollup",
              "style" : "",
              "id" : "DuplicateProductCategory_duplicateParentRollup",
              "title" : "Category Rollup : Parent Categories",
              "type" : "CHECK"
            }, {
              "fieldHelpText" : "",
              "name" : "duplicateChildRollup",
              "style" : "",
              "id" : "DuplicateProductCategory_duplicateChildRollup",
              "title" : "Category Rollup : Child Categories",
              "type" : "CHECK"
            }, {
              "fieldHelpText" : "",
              "name" : "duplicateMembers",
              "style" : "",
              "id" : "DuplicateProductCategory_duplicateMembers",
              "title" : "Products",
              "type" : "CHECK"
            }, {
              "fieldHelpText" : "",
              "name" : "duplicateCatalogs",
              "style" : "",
              "id" : "DuplicateProductCategory_duplicateCatalogs",
              "title" : "Catalogs",
              "type" : "CHECK"
            }, {
              "fieldHelpText" : "",
              "name" : "duplicateFeatureCategories",
              "style" : "",
              "id" : "DuplicateProductCategory_duplicateFeatureCategories",
              "title" : "Feature Categories",
              "type" : "CHECK"
            }, {
              "fieldHelpText" : "",
              "name" : "duplicateFeatureGroups",
              "style" : "",
              "id" : "DuplicateProductCategory_duplicateFeatureGroups",
              "title" : "Feature Groups",
              "type" : "CHECK"
            }, {
              "fieldHelpText" : "",
              "name" : "duplicateRoles",
              "style" : "",
              "id" : "DuplicateProductCategory_duplicateRoles",
              "title" : "PartyParties",
              "type" : "CHECK"
            }, {
              "fieldHelpText" : "",
              "name" : "duplicateAttributes",
              "style" : "",
              "id" : "DuplicateProductCategory_duplicateAttributes",
              "title" : "Attributes",
              "type" : "CHECK"
            }, {
              "buttonType" : "button",
              "alert" : "false",
              "formName" : "DuplicateProductCategory",
              "tabindex" : "",
              "name" : "submitButton",
              "className" : "smallSubmit",
              "id" : "DuplicateProductCategory_submitButton",
              "confirmation" : "",
              "type" : "SUBMIT",
              "title" : "CommonGo",
              "event" : "",
              "imgSrc" : ""
            } ],
            "target" : "DuplicateProductCategory"
          },
          "responseMessage" : "success"
        }
      },
      {
        "fieldSets" : [ {
          "fieldSetName" : "Default",
          "fields" : [ "contentId", "prodCatContentTypeId", "fromDate", "thruDate", "editLink", "deleteLink" ]
        } ],
        "columns" : [ {
          "name" : "contentId",
          "title" : "Content"
        }, {
          "name" : "prodCatContentTypeId",
          "title" : "Type"
        }, {
          "name" : "fromDate",
          "title" : "From Date"
        }, {
          "name" : "thruDate",
          "title" : "Thru Date"
        }, {
          "name" : "editLink",
          "title" : "Edit Content"
        }, {
          "name" : "deleteLink",
          "title" : " "
        } ],
        "formName" : "UpdateCategoryContentAssoc",
        "altTarget" : [ ],
        "formLocation" : "component://product/widget/catalog/CategoryForms.xml",
        "fields" : [ {
          "conditionGroup" : "",
          "name" : "productCategoryId",
          "action" : "",
          "id" : "UpdateCategoryContentAssoc_productCategoryId",
          "type" : "HIDDEN",
          "event" : "",
          "value" : ""
        }, {
          "hyperlink" : {
              "linkStyle" : "buttontext",
              "description" : "",
              "targetType" : "intra-app",
              "confirmation" : "",
              "parameterMap" : {
                "VIEW_SIZE_0" : "20",
                "VIEW_INDEX_0" : "0"
              },
              "uniqueItemName" : "Modal_6e4982f9_234c_4b6c_b0bd_f277cd5129fc",
              "target" : "EditCategoryContentContent",
              "targetWindow" : "",
              "remoteFormData":{
                    "formData":{
                        "formName":"EditCategoryContentContent",
                        "formLocation":"component://kwikstore/widget/ProductForms.xml",
                        "link":"/admin/categories/category/${productCategoryId}"
                    }
                },
          },
          "event":"edit",
          "fieldHelpText" : "",
          "ajaxEnabled" : false,
          "size" : 0,
          "name" : "contentId",
          "description" : "",
          "style" : "",
          "id" : "UpdateCategoryContentAssoc_contentId",
          "title" : "",
          "type" : "DISPLAY_ENTITY",
          "imageLocation" : ""
        }, {
          "fieldHelpText" : "",
          "ajaxEnabled" : false,
          "size" : 0,
          "name" : "prodCatContentTypeId",
          "description" : "",
          "style" : "",
          "id" : "UpdateCategoryContentAssoc_prodCatContentTypeId",
          "title" : "",
          "type" : "DISPLAY_ENTITY",
          "imageLocation" : ""
        }, {
          "fieldHelpText" : "",
          "ajaxEnabled" : false,
          "size" : 0,
          "name" : "fromDate",
          "description" : "",
          "style" : "",
          "id" : "UpdateCategoryContentAssoc_fromDate",
          "title" : "",
          "type" : "DISPLAY",
          "imageLocation" : ""
        }, {
          "fieldHelpText" : "",
          "ajaxEnabled" : false,
          "size" : 0,
          "name" : "thruDate",
          "description" : "",
          "style" : "",
          "id" : "UpdateCategoryContentAssoc_thruDate",
          "title" : "",
          "type" : "DISPLAY",
          "imageLocation" : ""
        }, {
          "image" : "",
          "fieldHelpText" : "",
          "alternate" : "",
          "description" : "",
          "title" : "Edit Content",
          "type" : "HYPERLINK",
          "name" : "editLink",
          "width" : "",
          "parameterList" : [ {
            "name" : "contentId"
          } ],
          "style" : "",
          "id" : "UpdateCategoryContentAssoc_editLink",
          "imageTitle" : "",
          "parameterMap" : { },
          "height" : "",
          "formData":{
              "formName":"UpdateCategoryContentAssoc",
              "formLocation":"component://product/widget/catalog/CategoryForms.xml",
              "viewIndex":1,
              "endPoint":"updateContentToCategory"
          },
          "event":"list",
        }, {
          "image" : "",
          "width" : "",
          "name" : "deleteLink",
          "alternate" : "",
          "description" : "CommonDelete",
          "parameterList" : [ {
            "name" : "productCategoryId"
          }, {
            "name" : "contentId"
          }, {
            "name" : "prodCatContentTypeId"
          }, {
            "name" : "fromDate"
          } ],
          "id" : "UpdateCategoryContentAssoc_deleteLink",
          "imageTitle" : "",
          "parameterMap" : { },
          "height" : ""
        } ],
        "target" : "updateContentToCategory"
      },
      {
        "statusCode" : 200,
        "statusDescription" : "OK",
        "successMessage" : "OK",
        "data" : {
          "formData" : {
            "formName" : "PrepareAddCategoryContentAssoc",
            "altTarget" : [ ],
            "formLocation" : "component://product/widget/catalog/CategoryForms.xml",
            "fields" : [ {
              "conditionGroup" : "",
              "name" : "productId",
              "action" : "",
              "id" : "PrepareAddCategoryContentAssoc_productId",
              "type" : "HIDDEN",
              "event" : "",
              "value" : ""
            }, {
              "conditionGroup" : "",
              "name" : "productCategoryId",
              "action" : "",
              "id" : "PrepareAddCategoryContentAssoc_productCategoryId",
              "type" : "HIDDEN",
              "event" : "",
              "value" : ""
            }, {
              "fieldName" : "",
              "firstInList" : "",
              "partialChars" : "",
              "conditionGroup" : "",
              "otherFieldName" : "",
              "className" : "",
              "title" : "Prod Cat Content Type ID",
              "type" : "DROP_DOWN",
              "frequency" : "",
              "minChars" : "",
              "allowEmpty" : "",
              "autoSelect" : "",
              "ajaxEnabled" : "false",
              "noCurrentSelectedKey" : "",
              "ajaxOptions" : "",
              "alert" : "false",
              "otherFieldSize" : "0",
              "ignoreCase" : "",
              "formName" : "PrepareAddCategoryContentAssoc",
              "options" : [ {
                "description" : "Alternative URL",
                "key" : "ALTERNATIVE_URL"
              }, {
                "description" : "Category Image",
                "key" : "CATEGORY_IMAGE"
              }, {
                "description" : "Category Image Alt Text",
                "key" : "CATEGORY_IMAGE_ALT"
              }, {
                "description" : "Category Image URL",
                "key" : "CATEGORY_IMAGE_URL"
              }, {
                "description" : "Category Name",
                "key" : "CATEGORY_NAME"
              }, {
                "description" : "Description",
                "key" : "DESCRIPTION"
              }, {
                "description" : "Description - Long",
                "key" : "LONG_DESCRIPTION"
              }, {
                "description" : "Footer",
                "key" : "FOOTER"
              }, {
                "description" : "Link 1 Alt Text",
                "key" : "LINK1_ALT_TEXT"
              }, {
                "description" : "Link 2 Alt Text",
                "key" : "LINK2_ALT_TEXT"
              }, {
                "description" : "Meta Description",
                "key" : "META_DESCRIPTION"
              }, {
                "description" : "Meta Keyword",
                "key" : "META_KEYWORD"
              }, {
                "description" : "Page Title",
                "key" : "PAGE_TITLE"
              }, {
                "description" : "Related URL",
                "key" : "RELATED_URL"
              }, {
                "description" : "Video",
                "key" : "VIDEO"
              }, {
                "description" : "Video URL",
                "key" : "VIDEO_URL"
              } ],
              "disabled" : "false",
              "id" : "PrepareAddCategoryContentAssoc_prodCatContentTypeId",
              "event" : "",
              "otherValue" : "",
              "fullSearch" : "",
              "fieldHelpText" : "",
              "dDFCurrent" : "selected",
              "tabindex" : "",
              "multiple" : "",
              "partialSearch" : "",
              "size" : "1",
              "name" : "prodCatContentTypeId",
              "style" : "",
              "explicitDescription" : "",
              "choices" : "",
              "currentValue" : ""
            }, {
              "buttonType" : "button",
              "alert" : "false",
              "formName" : "PrepareAddCategoryContentAssoc",
              "tabindex" : "",
              "name" : "submitButton",
              "className" : "smallSubmit",
              "id" : "PrepareAddCategoryContentAssoc_submitButton",
              "confirmation" : "",
              "type" : "SUBMIT",
              "title" : "",
              "event" : "",
              "imgSrc" : ""
            } ],
            "target" : "prepareAddContentToCategory"
          },
          "responseMessage" : "success"
        }
      },
      {
        "fieldSets" : [ {
          "fieldSetName" : "Default",
          "fields" : [ "contentId", "prodCatContentTypeId", "fromDate", "thruDate", "purchaseFromDate", "purchaseThruDate", "useCountLimit", "useDaysLimit", "submitButton" ]
        } ],
        "formName" : "AddCategoryContentAssoc",
        "altTarget" : [ ],
        "formLocation" : "component://product/widget/catalog/CategoryForms.xml",
        "fields" : [ {
          "conditionGroup" : "",
          "name" : "productCategoryId",
          "action" : "",
          "id" : "AddCategoryContentAssoc_productCategoryId",
          "type" : "HIDDEN",
          "event" : "",
          "value" : ""
        }, {
          "lookupOptions" : {
            "ajaxUrl" : "",
            "fadeBackground" : "true",
            "conditionGroup" : "",
            "targetParameterList" : [ "" ],
            "className" : "",
            "type" : "LOOKUP",
            "presentation" : "layer",
            "initiallyCollapsed" : "false",
            "ajaxEnabled" : "true",
            "showDescription" : "true",
            "delegatorName" : "",
            "readonly" : "false",
            "alert" : "false",
            "formName" : "AddCategoryContentAssoc",
            "id" : "AddCategoryContentAssoc_contentId",
            "event" : "",
            "value" : "",
            "fieldFormName" : "LookupContent",
            "maxlength" : "",
            "autocomplete" : "",
            "clearText" : "",
            "tabindex" : "",
            "size" : "25",
            "name" : "contentId",
            "descriptionFieldName" : "",
            "position" : "topleft",
            "imgSrc" : ""
          }
        }, {
          "fieldName" : "",
          "firstInList" : "",
          "partialChars" : "",
          "conditionGroup" : "",
          "otherFieldName" : "",
          "className" : "",
          "title" : "Prod Cat Content Type ID",
          "type" : "DROP_DOWN",
          "frequency" : "",
          "minChars" : "",
          "allowEmpty" : "",
          "autoSelect" : "",
          "ajaxEnabled" : "false",
          "noCurrentSelectedKey" : "",
          "ajaxOptions" : "",
          "alert" : "false",
          "otherFieldSize" : "0",
          "ignoreCase" : "",
          "formName" : "AddCategoryContentAssoc",
          "options" : [ {
            "description" : "Alternative URL",
            "key" : "ALTERNATIVE_URL"
          }, {
            "description" : "Category Image",
            "key" : "CATEGORY_IMAGE"
          }, {
            "description" : "Category Image Alt Text",
            "key" : "CATEGORY_IMAGE_ALT"
          }, {
            "description" : "Category Image URL",
            "key" : "CATEGORY_IMAGE_URL"
          }, {
            "description" : "Category Name",
            "key" : "CATEGORY_NAME"
          }, {
            "description" : "Description",
            "key" : "DESCRIPTION"
          }, {
            "description" : "Description - Long",
            "key" : "LONG_DESCRIPTION"
          }, {
            "description" : "Footer",
            "key" : "FOOTER"
          }, {
            "description" : "Link 1 Alt Text",
            "key" : "LINK1_ALT_TEXT"
          }, {
            "description" : "Link 2 Alt Text",
            "key" : "LINK2_ALT_TEXT"
          }, {
            "description" : "Meta Description",
            "key" : "META_DESCRIPTION"
          }, {
            "description" : "Meta Keyword",
            "key" : "META_KEYWORD"
          }, {
            "description" : "Page Title",
            "key" : "PAGE_TITLE"
          }, {
            "description" : "Related URL",
            "key" : "RELATED_URL"
          }, {
            "description" : "Video",
            "key" : "VIDEO"
          }, {
            "description" : "Video URL",
            "key" : "VIDEO_URL"
          } ],
          "disabled" : "false",
          "id" : "AddCategoryContentAssoc_prodCatContentTypeId",
          "event" : "",
          "otherValue" : "",
          "fullSearch" : "",
          "fieldHelpText" : "",
          "dDFCurrent" : "selected",
          "tabindex" : "",
          "multiple" : "",
          "partialSearch" : "",
          "size" : "1",
          "name" : "prodCatContentTypeId",
          "style" : "",
          "explicitDescription" : "",
          "choices" : "",
          "currentValue" : ""
        }, {
          "classString" : "",
          "shortDateInput" : "false",
          "ampmName" : "",
          "className" : "",
          "title" : "From Date",
          "type" : "DATE_TIME",
          "dateType" : "timestamp",
          "defaultDateTimeString" : "2023-02-05%2016:39:12.09",
          "timeDropdown" : "",
          "alert" : "false",
          "timeValues" : "",
          "formName" : "AddCategoryContentAssoc",
          "timeDropdownParamName" : "fromDate",
          "timeMinutesName" : "",
          "disabled" : "false",
          "id" : "AddCategoryContentAssoc_fromDate",
          "event" : "",
          "value" : "",
          "pmSelected" : "",
          "localizedInputTitle" : "",
          "mask" : "",
          "hour1" : "0",
          "isTwelveHour" : "false",
          "fieldHelpText" : "",
          "hour2" : "0",
          "maxlength" : "30",
          "minutes" : "0",
          "tabindex" : "",
          "amSelected" : "",
          "size" : "25",
          "isXMLHttpRequest" : "false",
          "localizedIconTitle" : "",
          "timeHourName" : "",
          "name" : "fromDate",
          "style" : "",
          "step" : "1",
          "compositeType" : ""
        }, {
          "classString" : "",
          "shortDateInput" : "false",
          "ampmName" : "",
          "className" : "",
          "title" : "Thru Date",
          "type" : "DATE_TIME",
          "dateType" : "timestamp",
          "defaultDateTimeString" : "2023-02-05%2016:39:12.094",
          "timeDropdown" : "",
          "alert" : "false",
          "timeValues" : "",
          "formName" : "AddCategoryContentAssoc",
          "timeDropdownParamName" : "thruDate",
          "timeMinutesName" : "",
          "disabled" : "false",
          "id" : "AddCategoryContentAssoc_thruDate",
          "event" : "",
          "value" : "",
          "pmSelected" : "",
          "localizedInputTitle" : "",
          "mask" : "",
          "hour1" : "0",
          "isTwelveHour" : "false",
          "fieldHelpText" : "",
          "hour2" : "0",
          "maxlength" : "30",
          "minutes" : "0",
          "tabindex" : "",
          "amSelected" : "",
          "size" : "25",
          "isXMLHttpRequest" : "false",
          "localizedIconTitle" : "",
          "timeHourName" : "",
          "name" : "thruDate",
          "style" : "",
          "step" : "1",
          "compositeType" : ""
        }, {
          "classString" : "",
          "shortDateInput" : "false",
          "ampmName" : "",
          "className" : "",
          "title" : "Purchase From Date",
          "type" : "DATE_TIME",
          "dateType" : "timestamp",
          "defaultDateTimeString" : "2023-02-05%2016:39:12.094",
          "timeDropdown" : "",
          "alert" : "false",
          "timeValues" : "",
          "formName" : "AddCategoryContentAssoc",
          "timeDropdownParamName" : "purchaseFromDate",
          "timeMinutesName" : "",
          "disabled" : "false",
          "id" : "AddCategoryContentAssoc_purchaseFromDate",
          "event" : "",
          "value" : "",
          "pmSelected" : "",
          "localizedInputTitle" : "",
          "mask" : "",
          "hour1" : "0",
          "isTwelveHour" : "false",
          "fieldHelpText" : "",
          "hour2" : "0",
          "maxlength" : "30",
          "minutes" : "0",
          "tabindex" : "",
          "amSelected" : "",
          "size" : "25",
          "isXMLHttpRequest" : "false",
          "localizedIconTitle" : "",
          "timeHourName" : "",
          "name" : "purchaseFromDate",
          "style" : "",
          "step" : "1",
          "compositeType" : ""
        }, {
          "classString" : "",
          "shortDateInput" : "false",
          "ampmName" : "",
          "className" : "",
          "title" : "Purchase Thru Date",
          "type" : "DATE_TIME",
          "dateType" : "timestamp",
          "defaultDateTimeString" : "2023-02-05%2016:39:12.094",
          "timeDropdown" : "",
          "alert" : "false",
          "timeValues" : "",
          "formName" : "AddCategoryContentAssoc",
          "timeDropdownParamName" : "purchaseThruDate",
          "timeMinutesName" : "",
          "disabled" : "false",
          "id" : "AddCategoryContentAssoc_purchaseThruDate",
          "event" : "",
          "value" : "",
          "pmSelected" : "",
          "localizedInputTitle" : "",
          "mask" : "",
          "hour1" : "0",
          "isTwelveHour" : "false",
          "fieldHelpText" : "",
          "hour2" : "0",
          "maxlength" : "30",
          "minutes" : "0",
          "tabindex" : "",
          "amSelected" : "",
          "size" : "25",
          "isXMLHttpRequest" : "false",
          "localizedIconTitle" : "",
          "timeHourName" : "",
          "name" : "purchaseThruDate",
          "style" : "",
          "step" : "1",
          "compositeType" : ""
        }, {
          "" : "",
          "fieldHelpText" : "",
          "textSize" : "6",
          "ajaxUrl" : "",
          "maxlength" : "",
          "tabindex" : "",
          "className" : "",
          "title" : "Use Count Limit",
          "type" : "TEXT",
          "clientAutocomplete" : "true",
          "ajaxEnabled" : true,
          "readonly" : false,
          "alert" : "false",
          "name" : "useCountLimit",
          "action" : "",
          "style" : "",
          "disabled" : false,
          "id" : "AddCategoryContentAssoc_useCountLimit",
          "placeholder" : "",
          "event" : "",
          "value" : "",
          "mask" : ""
        }, {
          "" : "",
          "fieldHelpText" : "",
          "textSize" : "6",
          "ajaxUrl" : "",
          "maxlength" : "",
          "tabindex" : "",
          "className" : "",
          "title" : "Use Days Limit",
          "type" : "TEXT",
          "clientAutocomplete" : "true",
          "ajaxEnabled" : true,
          "readonly" : false,
          "alert" : "false",
          "name" : "useDaysLimit",
          "action" : "",
          "style" : "",
          "disabled" : false,
          "id" : "AddCategoryContentAssoc_useDaysLimit",
          "placeholder" : "",
          "event" : "",
          "value" : "",
          "mask" : ""
        }, {
          "buttonType" : "button",
          "alert" : "false",
          "formName" : "AddCategoryContentAssoc",
          "tabindex" : "",
          "name" : "submitButton",
          "className" : "smallSubmit",
          "id" : "AddCategoryContentAssoc_submitButton",
          "confirmation" : "",
          "type" : "SUBMIT",
          "title" : "",
          "event" : "",
          "imgSrc" : ""
        } ],
        "target" : "addContentToCategory"
      },
      {
        "statusCode" : 200,
        "statusDescription" : "OK",
        "successMessage" : "OK",
        "data" : {
          "formData" : {
            "formName" : "EditCategoryContent",
            "altTarget" : [ ],
            "formLocation" : "component://kwikstore/widget/CategoryForms.xml",
            "fields" : [ {
              "conditionGroup" : "",
              "name" : "productCategoryId",
              "action" : "",
              "id" : "EditCategoryContent_productCategoryId",
              "type" : "HIDDEN",
              "event" : "",
              "value" : ""
            }, {
              "fieldName" : "",
              "firstInList" : "",
              "partialChars" : "",
              "conditionGroup" : "",
              "otherFieldName" : "",
              "className" : "",
              "title" : "Product Category Type ID",
              "type" : "DROP_DOWN",
              "frequency" : "",
              "minChars" : "",
              "allowEmpty" : "Y",
              "autoSelect" : "",
              "ajaxEnabled" : "false",
              "noCurrentSelectedKey" : "",
              "ajaxOptions" : "",
              "alert" : "false",
              "otherFieldSize" : "0",
              "ignoreCase" : "",
              "formName" : "EditCategoryContent",
              "options" : [ {
                "description" : "Best Selling",
                "key" : "BEST_SELL_CATEGORY"
              }, {
                "description" : "Catalog",
                "key" : "CATALOG_CATEGORY"
              }, {
                "description" : "Cross Sell",
                "key" : "CROSS_SELL_CATEGORY"
              }, {
                "description" : "Gift Cards",
                "key" : "GIFT_CARD_CATEGORY"
              }, {
                "description" : "Google Base",
                "key" : "GOOGLE_BASE_CATEGORY"
              }, {
                "description" : "Industry",
                "key" : "INDUSTRY_CATEGORY"
              }, {
                "description" : "Internal",
                "key" : "INTERNAL_CATEGORY"
              }, {
                "description" : "Materials",
                "key" : "MATERIALS_CATEGORY"
              }, {
                "description" : "Mix and Match",
                "key" : "MIXMATCH_CATEGORY"
              }, {
                "description" : "Quick Add",
                "key" : "QUICKADD_CATEGORY"
              }, {
                "description" : "Search",
                "key" : "SEARCH_CATEGORY"
              }, {
                "description" : "Tax",
                "key" : "TAX_CATEGORY"
              }, {
                "description" : "Usage",
                "key" : "USAGE_CATEGORY"
              }, {
                "description" : "eBay",
                "key" : "EBAY_CATEGORY"
              } ],
              "disabled" : "false",
              "id" : "EditCategoryContent_productCategoryTypeId",
              "event" : "",
              "otherValue" : "",
              "fullSearch" : "",
              "fieldHelpText" : "",
              "dDFCurrent" : "selected",
              "tabindex" : "",
              "multiple" : "",
              "partialSearch" : "",
              "size" : "1",
              "name" : "productCategoryTypeId",
              "style" : "",
              "explicitDescription" : "",
              "choices" : "",
              "currentValue" : ""
            }, {
              "" : "",
              "fieldHelpText" : "",
              "textSize" : "25",
              "ajaxUrl" : "",
              "maxlength" : "",
              "tabindex" : "",
              "className" : "",
              "title" : "ProductNamee",
              "type" : "TEXT",
              "clientAutocomplete" : "true",
              "ajaxEnabled" : true,
              "readonly" : false,
              "alert" : "false",
              "name" : "categoryName",
              "action" : "",
              "style" : "",
              "disabled" : false,
              "id" : "EditCategoryContent_categoryName",
              "placeholder" : "",
              "event" : "",
              "value" : "",
              "mask" : ""
            }, {
              "fieldHelpText" : "",
              "buttons" : "",
              "maxlength" : "",
              "tabindex" : "",
              "className" : "",
              "language" : "en",
              "title" : "Category Description",
              "type" : "TEXTAREA",
              "rows" : "3",
              "readonly" : "",
              "visualEditorEnable" : "",
              "alert" : "false",
              "name" : "description",
              "style" : "",
              "disabled" : "false",
              "id" : "EditCategoryContent_description",
              "value" : "",
              "cols" : "60"
            }, {
              "fieldHelpText" : "",
              "buttons" : "",
              "maxlength" : "",
              "tabindex" : "",
              "className" : "",
              "language" : "en",
              "title" : "Long Description",
              "type" : "TEXTAREA",
              "rows" : "3",
              "readonly" : "",
              "visualEditorEnable" : "",
              "alert" : "false",
              "name" : "longDescription",
              "style" : "",
              "disabled" : "false",
              "id" : "EditCategoryContent_longDescription",
              "value" : "",
              "cols" : "60"
            }, {
              "" : "",
              "fieldHelpText" : "",
              "textSize" : "25",
              "ajaxUrl" : "",
              "maxlength" : "",
              "tabindex" : "",
              "className" : "",
              "title" : "Detail Screen",
              "type" : "TEXT",
              "clientAutocomplete" : "true",
              "ajaxEnabled" : true,
              "readonly" : false,
              "alert" : "false",
              "name" : "detailScreen",
              "action" : "",
              "style" : "",
              "disabled" : false,
              "id" : "EditCategoryContent_detailScreen",
              "placeholder" : "",
              "event" : "",
              "value" : "",
              "mask" : ""
            }, {
              "buttonType" : "button",
              "alert" : "false",
              "formName" : "EditCategoryContent",
              "tabindex" : "",
              "name" : "submitButton",
              "className" : "smallSubmit",
              "id" : "EditCategoryContent_submitButton",
              "confirmation" : "",
              "type" : "SUBMIT",
              "title" : "CommonUpdate",
              "event" : "",
              "imgSrc" : ""
            } ],
            "target" : "updateCategoryContent"
          },
          "responseMessage" : "success"
        }
      },
      {
        "statusCode" : 200,
        "statusDescription" : "OK",
        "successMessage" : "OK",
        "data" : {
          "formData" : {
            "formName" : "EditCategoryContentSimpleText",
            "altTarget" : [ {
              "useWhen" : "content==null",
              "targetExdr" : {
                "chars" : "createSimpleTextContentForCategory",
                "hint" : 20,
                "original" : "createSimpleTextContentForCategory",
                "empty" : false
              }
            } ],
            "formLocation" : "component://product/widget/catalog/CategoryForms.xml",
            "fields" : [ {
              "conditionGroup" : "",
              "name" : "productCategoryId",
              "action" : "",
              "id" : "EditCategoryContentSimpleText_productCategoryId",
              "type" : "HIDDEN",
              "event" : "",
              "value" : ""
            }, {
              "conditionGroup" : "",
              "name" : "prodCatContentTypeId",
              "action" : "",
              "id" : "EditCategoryContentSimpleText_prodCatContentTypeId",
              "type" : "DISPLAY_ENTITY",
              "event" : "",
              "value" : ""
            }, {
              "conditionGroup" : "",
              "name" : "purchaseFromDate",
              "action" : "",
              "id" : "EditCategoryContentSimpleText_purchaseFromDate",
              "type" : "HIDDEN",
              "event" : "",
              "value" : ""
            }, {
              "conditionGroup" : "",
              "name" : "purchaseThruDate",
              "action" : "",
              "id" : "EditCategoryContentSimpleText_purchaseThruDate",
              "type" : "HIDDEN",
              "event" : "",
              "value" : ""
            }, {
              "conditionGroup" : "",
              "name" : "useCountLimit",
              "action" : "",
              "id" : "EditCategoryContentSimpleText_useCountLimit",
              "type" : "HIDDEN",
              "event" : "",
              "value" : ""
            }, {
              "conditionGroup" : "",
              "name" : "textDataResourceId",
              "action" : "",
              "id" : "EditCategoryContentSimpleText_textDataResourceId",
              "type" : "HIDDEN",
              "event" : "",
              "value" : ""
            }, {
              "fieldHelpText" : "",
              "ajaxEnabled" : false,
              "size" : 0,
              "name" : "prodCatContentTypeId",
              "description" : "",
              "style" : "",
              "id" : "EditCategoryContentSimpleText_prodCatContentTypeId",
              "title" : "",
              "type" : "DISPLAY_ENTITY",
              "imageLocation" : ""
            }, {
              "classString" : "",
              "shortDateInput" : "false",
              "ampmName" : "",
              "className" : "",
              "title" : "",
              "type" : "DATE_TIME",
              "dateType" : "timestamp",
              "defaultDateTimeString" : "2022-10-13%2015:47:04.811",
              "timeDropdown" : "text",
              "alert" : "false",
              "timeValues" : "",
              "formName" : "EditCategoryContentSimpleText",
              "timeDropdownParamName" : "fromDate",
              "timeMinutesName" : "",
              "disabled" : "false",
              "id" : "EditCategoryContentSimpleText_fromDate",
              "event" : "",
              "value" : "",
              "pmSelected" : "",
              "mask" : "",
              "hour1" : "0",
              "isTwelveHour" : "false",
              "fieldHelpText" : "",
              "hour2" : "0",
              "maxlength" : "30",
              "minutes" : "0",
              "tabindex" : "",
              "amSelected" : "",
              "size" : "25",
              "isXMLHttpRequest" : "false",
              "localizedIconTitle" : "",
              "timeHourName" : "",
              "name" : "fromDate",
              "style" : "",
              "step" : "1",
              "compositeType" : ""
            }, {
              "classString" : "",
              "shortDateInput" : "false",
              "ampmName" : "",
              "className" : "",
              "title" : "",
              "type" : "DATE_TIME",
              "dateType" : "timestamp",
              "defaultDateTimeString" : "2022-10-13%2015:47:04.812",
              "timeDropdown" : "",
              "alert" : "false",
              "timeValues" : "",
              "formName" : "EditCategoryContentSimpleText",
              "timeDropdownParamName" : "thruDate",
              "timeMinutesName" : "",
              "disabled" : "false",
              "id" : "EditCategoryContentSimpleText_thruDate",
              "event" : "",
              "value" : "",
              "pmSelected" : "",
              "mask" : "",
              "hour1" : "0",
              "isTwelveHour" : "false",
              "fieldHelpText" : "",
              "hour2" : "0",
              "maxlength" : "30",
              "minutes" : "0",
              "tabindex" : "",
              "amSelected" : "",
              "size" : "25",
              "isXMLHttpRequest" : "false",
              "localizedIconTitle" : "",
              "timeHourName" : "",
              "name" : "thruDate",
              "style" : "",
              "step" : "1",
              "compositeType" : ""
            }, {
              "" : "",
              "fieldHelpText" : "",
              "textSize" : "6",
              "ajaxUrl" : "",
              "maxlength" : "",
              "tabindex" : "",
              "className" : "",
              "title" : "Use Days Limit",
              "type" : "TEXT",
              "clientAutocomplete" : "true",
              "ajaxEnabled" : true,
              "readonly" : false,
              "alert" : "false",
              "name" : "useDaysLimit",
              "action" : "",
              "style" : "",
              "disabled" : false,
              "id" : "EditCategoryContentSimpleText_useDaysLimit",
              "placeholder" : "",
              "event" : "",
              "value" : "",
              "mask" : ""
            }, {
              "" : "",
              "fieldHelpText" : "",
              "textSize" : "40",
              "ajaxUrl" : "",
              "maxlength" : "",
              "tabindex" : "",
              "className" : "",
              "title" : "Description",
              "type" : "TEXT",
              "clientAutocomplete" : "true",
              "ajaxEnabled" : true,
              "readonly" : false,
              "alert" : "false",
              "name" : "description",
              "action" : "",
              "style" : "",
              "disabled" : false,
              "id" : "EditCategoryContentSimpleText_description",
              "placeholder" : "",
              "event" : "",
              "value" : "",
              "mask" : ""
            }, {
              "" : "",
              "fieldHelpText" : "",
              "textSize" : "40",
              "ajaxUrl" : "",
              "maxlength" : "",
              "tabindex" : "",
              "className" : "",
              "title" : "Locale String",
              "type" : "TEXT",
              "clientAutocomplete" : "true",
              "ajaxEnabled" : true,
              "readonly" : false,
              "alert" : "false",
              "name" : "localeString",
              "action" : "",
              "style" : "",
              "disabled" : false,
              "id" : "EditCategoryContentSimpleText_localeString",
              "placeholder" : "",
              "event" : "",
              "value" : "",
              "mask" : ""
            }, {
              "fieldHelpText" : "",
              "buttons" : "",
              "maxlength" : "",
              "tabindex" : "",
              "className" : "",
              "language" : "en",
              "title" : "Text",
              "type" : "TEXTAREA",
              "rows" : "10",
              "readonly" : "",
              "visualEditorEnable" : "",
              "alert" : "false",
              "name" : "text",
              "style" : "",
              "disabled" : "false",
              "id" : "EditCategoryContentSimpleText_text",
              "value" : "",
              "cols" : "80"
            }, {
              "buttonType" : "button",
              "alert" : "false",
              "formName" : "EditCategoryContentSimpleText",
              "tabindex" : "",
              "name" : "submitButton",
              "className" : "smallSubmit",
              "id" : "EditCategoryContentSimpleText_submitButton",
              "confirmation" : "",
              "type" : "SUBMIT",
              "title" : "",
              "event" : "",
              "imgSrc" : ""
            } ],
            "target" : "updateSimpleTextContentForCategory"
          },
          "responseMessage" : "success"
        }
      },
      {
        "statusCode" : 200,
        "statusDescription" : "OK",
        "successMessage" : "OK",
        "data" : {
          "formData" : {
            "formName" : "EditCategoryContentSEO",
            "altTarget" : [ ],
            "formLocation" : "component://product/widget/catalog/CategoryForms.xml",
            "fields" : [ {
              "conditionGroup" : "",
              "name" : "productCategoryId",
              "action" : "",
              "id" : "EditCategoryContentSEO_productCategoryId",
              "type" : "HIDDEN",
              "event" : "",
              "value" : ""
            }, {
              "conditionGroup" : "",
              "name" : "prodCatContentTypeId",
              "action" : "",
              "id" : "EditCategoryContentSEO_prodCatContentTypeId",
              "type" : "HIDDEN",
              "event" : "",
              "value" : ""
            }, {
              "" : "",
              "textSize" : "40",
              "ajaxUrl" : "",
              "maxlength" : "",
              "tabindex" : "",
              "className" : "",
              "clientAutocomplete" : "true",
              "ajaxEnabled" : true,
              "readonly" : false,
              "alert" : "false",
              "name" : "title",
              "action" : "",
              "disabled" : false,
              "id" : "EditCategoryContentSEO_title",
              "placeholder" : "",
              "event" : "",
              "value" : "",
              "mask" : ""
            }, {
              "buttons" : "",
              "maxlength" : "",
              "tabindex" : "",
              "className" : "",
              "language" : "en",
              "type" : "TEXTAREA",
              "rows" : "5",
              "readonly" : "",
              "visualEditorEnable" : "",
              "alert" : "false",
              "name" : "metaKeyword",
              "disabled" : "false",
              "id" : "EditCategoryContentSEO_metaKeyword",
              "value" : "",
              "cols" : "60"
            }, {
              "buttons" : "",
              "maxlength" : "",
              "tabindex" : "",
              "className" : "",
              "language" : "en",
              "type" : "TEXTAREA",
              "rows" : "5",
              "readonly" : "",
              "visualEditorEnable" : "",
              "alert" : "false",
              "name" : "metaDescription",
              "disabled" : "false",
              "id" : "EditCategoryContentSEO_metaDescription",
              "value" : "",
              "cols" : "60"
            }, {
              "buttonType" : "button",
              "alert" : "false",
              "formName" : "EditCategoryContentSEO",
              "tabindex" : "",
              "name" : "submitButton",
              "className" : "smallSubmit",
              "id" : "EditCategoryContentSEO_submitButton",
              "confirmation" : "",
              "type" : "SUBMIT",
              "title" : "",
              "event" : "",
              "imgSrc" : ""
            } ],
            "target" : "updateContentSEOForCategory"
          },
          "responseMessage" : "success"
        }
      },
      {
        "statusCode" : 200,
        "statusDescription" : "OK",
        "successMessage" : "OK",
        "data" : {
          "formData" : {
            "columns" : [ {
              "name" : "caContentAssocTypeId",
              "title" : "Ca Content Assoc Type ID"
            }, {
              "name" : "contentTypeId",
              "title" : "Content Type ID"
            }, {
              "name" : "localeString",
              "title" : "Locale String"
            }, {
              "name" : "drDataResourceTypeId",
              "title" : ""
            }, {
              "name" : "editDataResource",
              "title" : "Edit Data Resource"
            }, {
              "name" : "editContent",
              "title" : "Edit Content"
            } ],
            "formName" : "ListAssociatedContentInfos",
            "altTarget" : [ ],
            "formLocation" : "component://product/widget/catalog/ProductForms.xml",
            "fields" : [ {
              "fieldHelpText" : "",
              "ajaxEnabled" : false,
              "size" : 0,
              "name" : "caContentAssocTypeId",
              "description" : "",
              "style" : "",
              "id" : "ListAssociatedContentInfos_caContentAssocTypeId",
              "title" : "",
              "type" : "DISPLAY_ENTITY",
              "imageLocation" : ""
            }, {
              "fieldHelpText" : "",
              "ajaxEnabled" : false,
              "size" : 0,
              "name" : "contentTypeId",
              "description" : "",
              "style" : "",
              "id" : "ListAssociatedContentInfos_contentTypeId",
              "title" : "",
              "type" : "DISPLAY_ENTITY",
              "imageLocation" : ""
            }, {
              "fieldHelpText" : "",
              "ajaxEnabled" : false,
              "size" : 0,
              "name" : "localeString",
              "description" : "",
              "style" : "",
              "id" : "ListAssociatedContentInfos_localeString",
              "title" : "",
              "type" : "DISPLAY",
              "imageLocation" : ""
            }, {
              "ajaxEnabled" : false,
              "size" : 0,
              "name" : "drDataResourceTypeId",
              "description" : "",
              "id" : "ListAssociatedContentInfos_drDataResourceTypeId",
              "title" : "",
              "imageLocation" : ""
            }, {
              "image" : "",
              "fieldHelpText" : "",
              "alternate" : "",
              "description" : "",
              "title" : "Edit Data Resource",
              "type" : "HYPERLINK",
              "name" : "editDataResource",
              "width" : "",
              "parameterList" : [ {
                "name" : "dataResourceId"
              } ],
              "style" : "",
              "id" : "ListAssociatedContentInfos_editDataResource",
              "imageTitle" : "",
              "parameterMap" : { },
              "height" : ""
            }, {
              "image" : "",
              "fieldHelpText" : "",
              "alternate" : "",
              "description" : "",
              "title" : "Edit Content",
              "type" : "HYPERLINK",
              "name" : "editContent",
              "width" : "",
              "parameterList" : [ {
                "name" : "contentId"
              } ],
              "style" : "",
              "id" : "ListAssociatedContentInfos_editContent",
              "imageTitle" : "",
              "parameterMap" : { },
              "height" : ""
            } ],
            "target" : ""
          },
          "responseMessage" : "success"
        }
      },
      {
        "statusCode" : 200,
        "statusDescription" : "OK",
        "successMessage" : "OK",
        "data" : {
          "formData" : {
            "formName" : "CreateSimpleTextContentForAlternateLocale",
            "altTarget" : [ ],
            "formLocation" : "component://product/widget/catalog/CategoryForms.xml",
            "fields" : [ {
              "conditionGroup" : "",
              "name" : "productCategoryId",
              "action" : "",
              "id" : "CreateSimpleTextContentForAlternateLocale_productCategoryId",
              "type" : "HIDDEN",
              "event" : "",
              "value" : ""
            }, {
              "conditionGroup" : "",
              "name" : "mainContentId",
              "action" : "",
              "id" : "CreateSimpleTextContentForAlternateLocale_mainContentId",
              "type" : "HIDDEN",
              "event" : "",
              "value" : ""
            }, {
              "" : "",
              "fieldHelpText" : "",
              "textSize" : "25",
              "ajaxUrl" : "",
              "maxlength" : "",
              "tabindex" : "",
              "className" : "",
              "title" : "Locale String",
              "type" : "TEXT",
              "clientAutocomplete" : "true",
              "ajaxEnabled" : true,
              "readonly" : false,
              "alert" : "false",
              "name" : "localeString",
              "action" : "",
              "style" : "",
              "disabled" : false,
              "id" : "CreateSimpleTextContentForAlternateLocale_localeString",
              "placeholder" : "",
              "event" : "",
              "value" : "",
              "mask" : ""
            }, {
              "" : "",
              "fieldHelpText" : "",
              "textSize" : "25",
              "ajaxUrl" : "",
              "maxlength" : "",
              "tabindex" : "",
              "className" : "",
              "title" : "Text",
              "type" : "TEXT",
              "clientAutocomplete" : "true",
              "ajaxEnabled" : true,
              "readonly" : false,
              "alert" : "false",
              "name" : "text",
              "action" : "",
              "style" : "",
              "disabled" : false,
              "id" : "CreateSimpleTextContentForAlternateLocale_text",
              "placeholder" : "",
              "event" : "",
              "value" : "",
              "mask" : ""
            }, {
              "buttonType" : "button",
              "alert" : "false",
              "formName" : "CreateSimpleTextContentForAlternateLocale",
              "tabindex" : "",
              "name" : "submitButton",
              "className" : "",
              "id" : "CreateSimpleTextContentForAlternateLocale_submitButton",
              "confirmation" : "",
              "type" : "SUBMIT",
              "title" : "",
              "event" : "",
              "imgSrc" : ""
            } ],
            "target" : "createSimpleTextContentForAlternateLocaleInCategory"
          },
          "responseMessage" : "success"
        }
      },
      {
        "statusCode" : 200,
        "statusDescription" : "OK",
        "successMessage" : "OK",
        "data" : {
          "formData" : {
            "columns" : [ {
              "name" : "parentProductCategoryId",
              "title" : "Parent Category [ID]"
            }, {
              "name" : "fromDate",
              "title" : "From Date"
            }, {
              "name" : "thruDate",
              "title" : "Through Date"
            }, {
              "name" : "sequenceNum",
              "title" : "Sequence"
            }, {
              "name" : "deleteLink",
              "title" : " "
            }, {
              "name" : "submitButton",
              "title" : "Update"
            } ],
            "formName" : "ListCategoryRollup",
            "altTarget" : [ ],
            "formLocation" : "component://kwikstore/widget/CategoryForms.xml",
            "fields" : [ {
              "conditionGroup" : "",
              "name" : "productCategoryId",
              "action" : "",
              "id" : "ListCategoryRollup_productCategoryId",
              "type" : "HIDDEN",
              "event" : "",
              "value" : ""
            }, {
              "image" : "",
              "fieldHelpText" : "",
              "alternate" : "",
              "description" : " []",
              "title" : "Parent Category [ID]",
              "type" : "HYPERLINK",
              "name" : "parentProductCategoryId",
              "width" : "",
              "parameterList" : [ {
                "fromField" : {
                  "isEmpty" : false,
                  "original" : "parentProductCategoryId",
                  "bracketedOriginal" : "${parentProductCategoryId}",
                  "isAscending" : true,
                  "empty" : false,
                  "originalName" : "parentProductCategoryId"
                },
                "name" : "productCategoryId"
              } ],
              "style" : "",
              "id" : "ListCategoryRollup_parentProductCategoryId",
              "imageTitle" : "",
              "parameterMap" : { },
              "height" : ""
            }, {
              "fieldHelpText" : "",
              "ajaxEnabled" : false,
              "size" : 0,
              "name" : "fromDate",
              "description" : "",
              "style" : "",
              "id" : "ListCategoryRollup_fromDate",
              "title" : "",
              "type" : "DISPLAY",
              "imageLocation" : ""
            }, {
              "classString" : "",
              "shortDateInput" : "false",
              "ampmName" : "",
              "className" : "",
              "title" : "Format: yyyy-MM-dd HH:mm:ss.SSS",
              "type" : "DATE_TIME",
              "dateType" : "timestamp",
              "defaultDateTimeString" : "2022-10-17%2010:39:46.095",
              "timeDropdown" : "text",
              "alert" : "false",
              "timeValues" : "",
              "formName" : "ListCategoryRollup",
              "timeDropdownParamName" : "thruDate",
              "timeMinutesName" : "",
              "disabled" : "false",
              "id" : "ListCategoryRollup_thruDate",
              "event" : "",
              "value" : "",
              "pmSelected" : "",
              "mask" : "",
              "hour1" : "0",
              "isTwelveHour" : "false",
              "fieldHelpText" : "",
              "hour2" : "0",
              "maxlength" : "30",
              "minutes" : "0",
              "tabindex" : "",
              "amSelected" : "",
              "size" : "25",
              "isXMLHttpRequest" : "false",
              "localizedIconTitle" : "View Calendar",
              "timeHourName" : "",
              "name" : "thruDate",
              "style" : "",
              "step" : "1",
              "compositeType" : ""
            }, {
              "" : "",
              "fieldHelpText" : "",
              "textSize" : "25",
              "ajaxUrl" : "",
              "maxlength" : "",
              "tabindex" : "",
              "className" : "",
              "title" : "Sequence",
              "type" : "TEXT",
              "clientAutocomplete" : "true",
              "ajaxEnabled" : true,
              "readonly" : false,
              "alert" : "false",
              "name" : "sequenceNum",
              "action" : "",
              "style" : "",
              "disabled" : false,
              "id" : "ListCategoryRollup_sequenceNum",
              "placeholder" : "",
              "event" : "",
              "value" : "",
              "mask" : ""
            }, {
              "image" : "",
              "width" : "",
              "name" : "deleteLink",
              "alternate" : "",
              "description" : "Delete",
              "parameterList" : [ {
                "name" : "productCategoryId"
              }, {
                "name" : "parentProductCategoryId"
              }, {
                "name" : "fromDate"
              } ],
              "id" : "ListCategoryRollup_deleteLink",
              "imageTitle" : "",
              "parameterMap" : { },
              "height" : ""
            }, {
              "buttonType" : "button",
              "alert" : "false",
              "formName" : "ListCategoryRollup",
              "tabindex" : "",
              "name" : "submitButton",
              "className" : "smallSubmit",
              "id" : "ListCategoryRollup_submitButton",
              "confirmation" : "",
              "type" : "SUBMIT",
              "title" : "Update",
              "event" : "",
              "imgSrc" : ""
            } ],
            "target" : "updateProductCategoryToCategory"
          },
          "responseMessage" : "success"
        }
      },
      {
        "statusCode" : 200,
        "statusDescription" : "OK",
        "successMessage" : "OK",
        "data" : {
          "formData" : {
            "formName" : "AddProductCategoryParent",
            "altTarget" : [ ],
            "formLocation" : "component://kwikstore/widget/CategoryForms.xml",
            "fields" : [ {
              "conditionGroup" : "",
              "name" : "productCategoryId",
              "action" : "",
              "id" : "AddProductCategoryParent_productCategoryId",
              "type" : "HIDDEN",
              "event" : "",
              "value" : ""
            }, {
              "fieldHelpText" : "",
              "lookupOptions" : {
                "ajaxUrl" : "",
                "fadeBackground" : "true",
                "conditionGroup" : "",
                "targetParameterList" : [ "" ],
                "className" : "",
                "type" : "LOOKUP",
                "presentation" : "layer",
                "initiallyCollapsed" : "false",
                "ajaxEnabled" : "true",
                "showDescription" : "true",
                "delegatorName" : "",
                "readonly" : "false",
                "alert" : "false",
                "formName" : "AddProductCategoryParent",
                "id" : "AddProductCategoryParent_parentProductCategoryId",
                "event" : "",
                "value" : "",
                "fieldFormName" : "LookupProductCategory",
                "maxlength" : "",
                "autocomplete" : "",
                "clearText" : "Clear",
                "tabindex" : "",
                "size" : "25",
                "name" : "parentProductCategoryId",
                "descriptionFieldName" : "",
                "position" : "topleft",
                "imgSrc" : ""
              },
              "name" : "parentProductCategoryId",
              "style" : "",
              "id" : "AddProductCategoryParent_parentProductCategoryId",
              "title" : "Parent Category [ID]",
              "type" : "LOOKUP"
            }, {
              "classString" : "",
              "shortDateInput" : "false",
              "ampmName" : "",
              "className" : "required",
              "title" : "Format: yyyy-MM-dd HH:mm:ss.SSS",
              "type" : "DATE_TIME",
              "dateType" : "timestamp",
              "defaultDateTimeString" : "2022-10-17%2011:18:30.811",
              "timeDropdown" : "",
              "alert" : "false",
              "timeValues" : "",
              "formName" : "AddProductCategoryParent",
              "timeDropdownParamName" : "fromDate",
              "timeMinutesName" : "",
              "disabled" : "false",
              "id" : "AddProductCategoryParent_fromDate",
              "event" : "",
              "value" : "",
              "pmSelected" : "",
              "mask" : "",
              "hour1" : "0",
              "isTwelveHour" : "false",
              "fieldHelpText" : "",
              "hour2" : "0",
              "maxlength" : "30",
              "minutes" : "0",
              "tabindex" : "",
              "amSelected" : "",
              "size" : "25",
              "isXMLHttpRequest" : "false",
              "localizedIconTitle" : "View Calendar",
              "timeHourName" : "",
              "name" : "fromDate",
              "style" : "",
              "step" : "1",
              "compositeType" : ""
            }, {
              "classString" : "",
              "shortDateInput" : "false",
              "ampmName" : "",
              "className" : "",
              "title" : "Format: yyyy-MM-dd HH:mm:ss.SSS",
              "type" : "DATE_TIME",
              "dateType" : "timestamp",
              "defaultDateTimeString" : "2022-10-17%2011:18:30.812",
              "timeDropdown" : "",
              "alert" : "false",
              "timeValues" : "",
              "formName" : "AddProductCategoryParent",
              "timeDropdownParamName" : "thruDate",
              "timeMinutesName" : "",
              "disabled" : "false",
              "id" : "AddProductCategoryParent_thruDate",
              "event" : "",
              "value" : "",
              "pmSelected" : "",
              "mask" : "",
              "hour1" : "0",
              "isTwelveHour" : "false",
              "fieldHelpText" : "",
              "hour2" : "0",
              "maxlength" : "30",
              "minutes" : "0",
              "tabindex" : "",
              "amSelected" : "",
              "size" : "25",
              "isXMLHttpRequest" : "false",
              "localizedIconTitle" : "View Calendar",
              "timeHourName" : "",
              "name" : "thruDate",
              "style" : "",
              "step" : "1",
              "compositeType" : ""
            }, {
              "" : "",
              "fieldHelpText" : "",
              "textSize" : "6",
              "ajaxUrl" : "",
              "maxlength" : "",
              "tabindex" : "",
              "className" : "",
              "title" : "Sequence Num",
              "type" : "TEXT",
              "clientAutocomplete" : "true",
              "ajaxEnabled" : true,
              "readonly" : false,
              "alert" : "false",
              "name" : "sequenceNum",
              "action" : "",
              "style" : "",
              "disabled" : false,
              "id" : "AddProductCategoryParent_sequenceNum",
              "placeholder" : "",
              "event" : "",
              "value" : "",
              "mask" : ""
            }, {
              "buttonType" : "button",
              "alert" : "false",
              "formName" : "AddProductCategoryParent",
              "tabindex" : "",
              "name" : "submitButton",
              "className" : "smallSubmit",
              "id" : "AddProductCategoryParent_submitButton",
              "confirmation" : "",
              "type" : "SUBMIT",
              "title" : "Add",
              "event" : "",
              "imgSrc" : ""
            } ],
            "target" : "addProductCategoryToCategory"
          },
          "responseMessage" : "success"
        }
      },
      {
        "statusCode" : 200,
        "statusDescription" : "OK",
        "successMessage" : "OK",
        "data" : {
          "formData" : {
            "columns" : [ {
              "name" : "productCategoryId",
              "title" : "Child Category ID"
            }, {
              "name" : "fromDate",
              "title" : "From Date"
            }, {
              "name" : "thruDate",
              "title" : "Through Date"
            }, {
              "name" : "sequenceNum",
              "title" : "Sequence"
            }, {
              "name" : "deleteLink",
              "title" : " "
            }, {
              "name" : "submitButton",
              "title" : "Update"
            } ],
            "formName" : "ListCategoryRollupChildCategories",
            "altTarget" : [ ],
            "formLocation" : "component://kwikstore/widget/CategoryForms.xml",
            "fields" : [ {
              "conditionGroup" : "",
              "name" : "parentProductCategoryId",
              "action" : "",
              "id" : "ListCategoryRollupChildCategories_parentProductCategoryId",
              "type" : "HIDDEN",
              "event" : "",
              "value" : ""
            }, {
              "image" : "",
              "fieldHelpText" : "",
              "alternate" : "",
              "description" : " []",
              "title" : "Child Category ID",
              "type" : "HYPERLINK",
              "name" : "productCategoryId",
              "width" : "",
              "parameterList" : [ {
                "fromField" : {
                  "isEmpty" : false,
                  "original" : "productCategoryId",
                  "bracketedOriginal" : "${productCategoryId}",
                  "isAscending" : true,
                  "empty" : false,
                  "originalName" : "productCategoryId"
                },
                "name" : "productCategoryId"
              } ],
              "style" : "",
              "id" : "ListCategoryRollupChildCategories_productCategoryId",
              "imageTitle" : "",
              "parameterMap" : { },
              "height" : ""
            }, {
              "fieldHelpText" : "",
              "ajaxEnabled" : false,
              "size" : 0,
              "name" : "fromDate",
              "description" : "",
              "style" : "",
              "id" : "ListCategoryRollupChildCategories_fromDate",
              "title" : "",
              "type" : "DISPLAY",
              "imageLocation" : ""
            }, {
              "classString" : "",
              "shortDateInput" : "false",
              "ampmName" : "",
              "className" : "",
              "title" : "Format: yyyy-MM-dd HH:mm:ss.SSS",
              "type" : "DATE_TIME",
              "dateType" : "timestamp",
              "defaultDateTimeString" : "2022-10-17%2013:43:39.112",
              "timeDropdown" : "text",
              "alert" : "false",
              "timeValues" : "",
              "formName" : "ListCategoryRollupChildCategories",
              "timeDropdownParamName" : "thruDate",
              "timeMinutesName" : "",
              "disabled" : "false",
              "id" : "ListCategoryRollupChildCategories_thruDate",
              "event" : "",
              "value" : "",
              "pmSelected" : "",
              "mask" : "",
              "hour1" : "0",
              "isTwelveHour" : "false",
              "fieldHelpText" : "",
              "hour2" : "0",
              "maxlength" : "30",
              "minutes" : "0",
              "tabindex" : "",
              "amSelected" : "",
              "size" : "25",
              "isXMLHttpRequest" : "false",
              "localizedIconTitle" : "View Calendar",
              "timeHourName" : "",
              "name" : "thruDate",
              "style" : "",
              "step" : "1",
              "compositeType" : ""
            }, {
              "" : "",
              "fieldHelpText" : "",
              "textSize" : "25",
              "ajaxUrl" : "",
              "maxlength" : "",
              "tabindex" : "",
              "className" : "",
              "title" : "Sequence",
              "type" : "TEXT",
              "clientAutocomplete" : "true",
              "ajaxEnabled" : true,
              "readonly" : false,
              "alert" : "false",
              "name" : "sequenceNum",
              "action" : "",
              "style" : "",
              "disabled" : false,
              "id" : "ListCategoryRollupChildCategories_sequenceNum",
              "placeholder" : "",
              "event" : "",
              "value" : "",
              "mask" : ""
            }, {
              "image" : "",
              "width" : "",
              "name" : "deleteLink",
              "alternate" : "",
              "description" : "Delete",
              "parameterList" : [ {
                "name" : "productCategoryId"
              }, {
                "name" : "parentProductCategoryId"
              }, {
                "name" : "fromDate"
              } ],
              "id" : "ListCategoryRollupChildCategories_deleteLink",
              "imageTitle" : "",
              "parameterMap" : { },
              "height" : ""
            }, {
              "buttonType" : "button",
              "alert" : "false",
              "formName" : "ListCategoryRollupChildCategories",
              "tabindex" : "",
              "name" : "submitButton",
              "className" : "smallSubmit",
              "id" : "ListCategoryRollupChildCategories_submitButton",
              "confirmation" : "",
              "type" : "SUBMIT",
              "title" : "Update",
              "event" : "",
              "imgSrc" : ""
            } ],
            "target" : "updateProductCategoryToCategory"
          },
          "responseMessage" : "success"
        }
      },
      {
        "statusCode" : 200,
        "statusDescription" : "OK",
        "successMessage" : "OK",
        "data" : {
          "formData" : {
            "formName" : "AddProductCategoryChild",
            "altTarget" : [ ],
            "formLocation" : "component://kwikstore/widget/CategoryForms.xml",
            "fields" : [ {
              "conditionGroup" : "",
              "name" : "parentProductCategoryId",
              "action" : "",
              "id" : "AddProductCategoryChild_parentProductCategoryId",
              "type" : "HIDDEN",
              "event" : "",
              "value" : ""
            }, {
              "fieldHelpText" : "",
              "lookupOptions" : {
                "ajaxUrl" : "",
                "fadeBackground" : "true",
                "conditionGroup" : "",
                "targetParameterList" : [ "" ],
                "className" : "",
                "type" : "LOOKUP",
                "presentation" : "layer",
                "initiallyCollapsed" : "false",
                "ajaxEnabled" : "true",
                "showDescription" : "true",
                "delegatorName" : "",
                "readonly" : "false",
                "alert" : "false",
                "formName" : "AddProductCategoryChild",
                "id" : "AddProductCategoryChild_productCategoryId",
                "event" : "",
                "value" : "",
                "fieldFormName" : "LookupProductCategory",
                "maxlength" : "",
                "autocomplete" : "",
                "clearText" : "Clear",
                "tabindex" : "",
                "size" : "25",
                "name" : "productCategoryId",
                "descriptionFieldName" : "",
                "position" : "topleft",
                "imgSrc" : ""
              },
              "name" : "productCategoryId",
              "style" : "",
              "id" : "AddProductCategoryChild_productCategoryId",
              "title" : "Child Category ID",
              "type" : "LOOKUP"
            }, {
              "classString" : "",
              "shortDateInput" : "false",
              "ampmName" : "",
              "className" : "",
              "title" : "Format: yyyy-MM-dd HH:mm:ss.SSS",
              "type" : "DATE_TIME",
              "dateType" : "timestamp",
              "defaultDateTimeString" : "2022-10-17%2013:44:40.998",
              "timeDropdown" : "text",
              "alert" : "false",
              "timeValues" : "",
              "formName" : "AddProductCategoryChild",
              "timeDropdownParamName" : "fromDate",
              "timeMinutesName" : "",
              "disabled" : "false",
              "id" : "AddProductCategoryChild_fromDate",
              "event" : "",
              "value" : "",
              "pmSelected" : "",
              "mask" : "",
              "hour1" : "0",
              "isTwelveHour" : "false",
              "fieldHelpText" : "",
              "hour2" : "0",
              "maxlength" : "30",
              "minutes" : "0",
              "tabindex" : "",
              "amSelected" : "",
              "size" : "25",
              "isXMLHttpRequest" : "false",
              "localizedIconTitle" : "View Calendar",
              "timeHourName" : "",
              "name" : "fromDate",
              "style" : "",
              "step" : "1",
              "compositeType" : ""
            }, {
              "buttonType" : "button",
              "alert" : "false",
              "formName" : "AddProductCategoryChild",
              "tabindex" : "",
              "name" : "submitButton",
              "className" : "smallSubmit",
              "id" : "AddProductCategoryChild_submitButton",
              "confirmation" : "",
              "type" : "SUBMIT",
              "title" : "Add",
              "event" : "",
              "imgSrc" : ""
            } ],
            "target" : "addProductCategoryToCategory"
          },
          "responseMessage" : "success"
        }
      },
      {
        "fieldSets" : [ {
          "fieldSetName" : "Default",
          "fields" : [ "partyId", "roleTypeId", "fromDate", "thruDate", "deleteLink", "submitButton" ]
        } ],
        "columns" : [ {
          "name" : "partyId",
          "title" : "Party"
        }, {
          "name" : "roleTypeId",
          "title" : "Role"
        }, {
          "name" : "fromDate",
          "title" : "From Date  Time"
        }, {
          "name" : "thruDate",
          "title" : "Through Date  Time"
        }, {
          "name" : "deleteLink",
          "title" : "Delete"
        }, {
          "name" : "submitButton",
          "title" : "Update"
        } ],
        "formName" : "ListCategoryParties",
        "altTarget" : [ ],
        "formLocation" : "component://kwikstore/widget/CategoryForms.xml",
        "fields" : [ {
          "conditionGroup" : "",
          "name" : "productCategoryId",
          "action" : "",
          "id" : "ListCategoryParties_productCategoryId",
          "type" : "HIDDEN",
          "event" : "",
          "value" : ""
        }, {
          "hyperlink" : {
            "linkStyle" : "buttontext",
            "description" : "",
            "targetType" : "inter-app",
            "confirmation" : "",
            "parameterMap" : {
              "VIEW_SIZE_0" : "20",
              "VIEW_INDEX_0" : "0"
            },
            "uniqueItemName" : "Modal_31e717a8_ed88_4feb_99f9_494cbc66784b",
            "target" : "/partymgr/control/viewprofile",
            "targetWindow" : "",
            "remoteFormData":{
                "formData":{
                    "formName":"ListCategoryParties",
                    "formLocation":"component://kwikstore/widget/CategoryForms.xml",
                    "link":"/admin/categories/category/${productCategoryId}"
                }
            }
          },
          "event":"list",
          "fieldHelpText" : "",
          "ajaxEnabled" : false,
          "size" : 0,
          "name" : "partyId",
          "description" : "",
          "style" : "",
          "id" : "ListCategoryParties_partyId",
          "title" : "",
          "type" : "DISPLAY_ENTITY",
          "imageLocation" : ""
        }, {
          "fieldHelpText" : "",
          "ajaxEnabled" : false,
          "size" : 0,
          "name" : "roleTypeId",
          "description" : "",
          "style" : "",
          "id" : "ListCategoryParties_roleTypeId",
          "title" : "",
          "type" : "DISPLAY_ENTITY",
          "imageLocation" : ""
        }, {
          "fieldHelpText" : "",
          "ajaxEnabled" : false,
          "size" : 0,
          "name" : "fromDate",
          "description" : "",
          "style" : "",
          "id" : "ListCategoryParties_fromDate",
          "title" : "",
          "type" : "DISPLAY",
          "imageLocation" : ""
        }, {
          "classString" : "",
          "shortDateInput" : "false",
          "ampmName" : "",
          "className" : "",
          "title" : "Through Date  Time",
          "type" : "DATE_TIME",
          "dateType" : "timestamp",
          "defaultDateTimeString" : "2023-02-11%2011:08:50.285",
          "timeDropdown" : "text",
          "alert" : "false",
          "timeValues" : "",
          "formName" : "ListCategoryParties",
          "timeDropdownParamName" : "thruDate",
          "timeMinutesName" : "",
          "disabled" : "false",
          "id" : "ListCategoryParties_thruDate",
          "event" : "",
          "value" : "",
          "pmSelected" : "",
          "localizedInputTitle" : "Format: yyyy-MM-dd HH:mm:ss.SSS",
          "mask" : "",
          "hour1" : "0",
          "isTwelveHour" : "false",
          "fieldHelpText" : "",
          "hour2" : "0",
          "maxlength" : "30",
          "minutes" : "0",
          "tabindex" : "",
          "amSelected" : "",
          "size" : "25",
          "isXMLHttpRequest" : "false",
          "localizedIconTitle" : "View Calendar",
          "timeHourName" : "",
          "name" : "thruDate",
          "style" : "",
          "step" : "1",
          "compositeType" : ""
        }, {
          "image" : "",
          "fieldHelpText" : "",
          "alternate" : "",
          "description" : "Delete",
          "title" : "Delete",
          "type" : "HYPERLINK",
          "name" : "deleteLink",
          "width" : "",
          "parameterList" : [ {
            "name" : "productCategoryId"
          }, {
            "name" : "partyId"
          }, {
            "name" : "roleTypeId"
          }, {
            "name" : "fromDate"
          } ],
          "style" : "",
          "id" : "ListCategoryParties_deleteLink",
          "imageTitle" : "",
          "parameterMap" : { },
          "height" : "",
          "formData":{
              "formName":"ListCategoryParties",
              "formLocation":"component://kwikstore/widget/CategoryForms.xml",
              "link":"/admin/categories/category/${productCategoryId}"
          },
          "event":"delete"
        }, {
          "buttonType" : "button",
          "alert" : "false",
          "formName" : "ListCategoryParties",
          "tabindex" : "",
          "name" : "submitButton",
          "className" : "smallSubmit",
          "id" : "ListCategoryParties_submitButton",
          "confirmation" : "",
          "type" : "SUBMIT",
          "title" : "Update",
          "event" : "",
          "imgSrc" : ""
        } ],
        "target" : "updatePartyToCategory"
      },
      {
        "fieldSets" : [ {
          "fieldSetName" : "Default",
          "fields" : [ "partyId", "roleTypeId", "fromDate", "submitButton" ]
        } ],
        "formName" : "AddPartyToCategory",
        "altTarget" : [ ],
        "formLocation" : "component://kwikstore/widget/CategoryForms.xml",
        "fields" : [ {
          "conditionGroup" : "",
          "name" : "productCategoryId",
          "action" : "",
          "id" : "AddPartyToCategory_productCategoryId",
          "type" : "HIDDEN",
          "event" : "",
          "value" : ""
        }, {
          "fieldHelpText" : "",
          "lookupOptions" : {
            "ajaxUrl" : "",
            "fadeBackground" : "true",
            "conditionGroup" : "",
            "targetParameterList" : [ "" ],
            "className" : "required",
            "type" : "LOOKUP",
            "presentation" : "layer",
            "initiallyCollapsed" : "false",
            "ajaxEnabled" : "true",
            "showDescription" : "true",
            "delegatorName" : "",
            "readonly" : "false",
            "alert" : "false",
            "formName" : "AddPartyToCategory",
            "id" : "AddPartyToCategory_partyId",
            "event" : "",
            "value" : "",
            "fieldFormName" : "LookupPartyName",
            "maxlength" : "",
            "autocomplete" : "",
            "clearText" : "Clear",
            "tabindex" : "",
            "size" : "25",
            "name" : "partyId",
            "descriptionFieldName" : "",
            "position" : "topleft",
            "imgSrc" : ""
          },
          "name" : "partyId",
          "style" : "",
          "id" : "AddPartyToCategory_partyId",
          "title" : "Party",
          "type" : "LOOKUP"
        }, {
          "fieldName" : "",
          "firstInList" : "",
          "partialChars" : "",
          "conditionGroup" : "",
          "otherFieldName" : "",
          "className" : "",
          "title" : "Role",
          "type" : "DROP_DOWN",
          "frequency" : "",
          "minChars" : "",
          "allowEmpty" : "",
          "autoSelect" : "",
          "ajaxEnabled" : "false",
          "noCurrentSelectedKey" : "",
          "ajaxOptions" : "",
          "alert" : "false",
          "otherFieldSize" : "0",
          "ignoreCase" : "",
          "formName" : "AddPartyToCategory",
          "options" : [ {
            "description" : "Account",
            "key" : "ACCOUNT"
          }, {
            "description" : "Account Lead",
            "key" : "ACCOUNT_LEAD"
          }, {
            "description" : "Accountant",
            "key" : "ACCOUNTANT"
          }, {
            "description" : "Addressee",
            "key" : "ADDRESSEE"
          }, {
            "description" : "Administrator",
            "key" : "ADMIN"
          }, {
            "description" : "Affiliate",
            "key" : "AFFILIATE"
          }, {
            "description" : "Agent",
            "key" : "AGENT"
          }, {
            "description" : "Approver",
            "key" : "APPROVER"
          }, {
            "description" : "Association",
            "key" : "ASSOCIATION"
          }, {
            "description" : "Automated Agent",
            "key" : "AUTOMATED_AGENT_ROLE"
          }, {
            "description" : "Bill-From Vendor",
            "key" : "BILL_FROM_VENDOR"
          }, {
            "description" : "Bill-To Customer",
            "key" : "BILL_TO_CUSTOMER"
          }, {
            "description" : "Blind Copy",
            "key" : "BCC"
          }, {
            "description" : "Budget Application",
            "key" : "BUDGET_APPL"
          }, {
            "description" : "Budget Approver",
            "key" : "BUDGET_APPRV"
          }, {
            "description" : "Budget Manager",
            "key" : "BUDGET_MGR"
          }, {
            "description" : "Budget Reviewer",
            "key" : "BUDGET_RVR"
          }, {
            "description" : "Budget Roles Group (not to be assigned to parties)",
            "key" : "BUDGET"
          }, {
            "description" : "Bulk Customer",
            "key" : "BULK_CUSTOMER"
          }, {
            "description" : "Buyer",
            "key" : "BUYER"
          }, {
            "description" : "Calendar",
            "key" : "CALENDAR_ROLE"
          }, {
            "description" : "Calendar Attendee",
            "key" : "CAL_ATTENDEE"
          }, {
            "description" : "Calendar Delegate",
            "key" : "CAL_DELEGATE"
          }, {
            "description" : "Calendar Host",
            "key" : "CAL_HOST"
          }, {
            "description" : "Calendar Member",
            "key" : "ICAL_MEMBER"
          }, {
            "description" : "Calendar Organizer",
            "key" : "CAL_ORGANIZER"
          }, {
            "description" : "Calendar Owner",
            "key" : "CAL_OWNER"
          }, {
            "description" : "Carbon Copy",
            "key" : "CC"
          }, {
            "description" : "Carrier",
            "key" : "CARRIER"
          }, {
            "description" : "Cashier",
            "key" : "CASHIER"
          }, {
            "description" : "Client",
            "key" : "CLIENT"
          }, {
            "description" : "Client Analyst",
            "key" : "CLIENT_ANALYST"
          }, {
            "description" : "Client Billing",
            "key" : "CLIENT_BILLING"
          }, {
            "description" : "Client Manager",
            "key" : "CLIENT_MANAGER"
          }, {
            "description" : "Communication Participant",
            "key" : "COMMEVENT_ROLE"
          }, {
            "description" : "Competitor",
            "key" : "COMPETITOR"
          }, {
            "description" : "Consumer",
            "key" : "CONSUMER"
          }, {
            "description" : "Contact",
            "key" : "CONTACT"
          }, {
            "description" : "Content Administrator",
            "key" : "CONTENT_ADMIN"
          }, {
            "description" : "Content Author",
            "key" : "CONTENT_AUTHOR"
          }, {
            "description" : "Content Editor",
            "key" : "CONTENT_EDITOR"
          }, {
            "description" : "Content Guest",
            "key" : "CONTENT_GUEST"
          }, {
            "description" : "Content Member",
            "key" : "CONTENT"
          }, {
            "description" : "Content Publisher",
            "key" : "CONTENT_PUBLISHER"
          }, {
            "description" : "Content User",
            "key" : "CONTENT_USER"
          }, {
            "description" : "Contractor",
            "key" : "CONTRACTOR"
          }, {
            "description" : "Customer",
            "key" : "CUSTOMER"
          }, {
            "description" : "Department",
            "key" : "DEPARTMENT"
          }, {
            "description" : "Distribution Channel",
            "key" : "DISTRIBUTION_CHANNEL"
          }, {
            "description" : "Distributor",
            "key" : "DISTRIBUTOR"
          }, {
            "description" : "Division",
            "key" : "DIVISION"
          }, {
            "description" : "Email Administrator",
            "key" : "EMAIL_ADMIN"
          }, {
            "description" : "Employee",
            "key" : "EMPLOYEE"
          }, {
            "description" : "Employer",
            "key" : "EMPLOYER"
          }, {
            "description" : "End-User Customer",
            "key" : "END_USER_CUSTOMER"
          }, {
            "description" : "Family Member",
            "key" : "FAMILY_MEMBER"
          }, {
            "description" : "Fixed Asset Maint Assignee",
            "key" : "FAM_ASSIGNEE"
          }, {
            "description" : "Government Agency",
            "key" : "GOV_AGENCY"
          }, {
            "description" : "Hosting Server",
            "key" : "HOSTING_SERVER"
          }, {
            "description" : "Household",
            "key" : "HOUSEHOLD"
          }, {
            "description" : "ISP",
            "key" : "ISP"
          }, {
            "description" : "Image Approver",
            "key" : "IMAGEAPPROVER"
          }, {
            "description" : "Internal Organization",
            "key" : "INTERNAL_ORGANIZATIO"
          }, {
            "description" : "Lead",
            "key" : "LEAD"
          }, {
            "description" : "Limited Administrator",
            "key" : "LTD_ADMIN"
          }, {
            "description" : "Logged In",
            "key" : "LOGGEDIN"
          }, {
            "description" : "Main Role",
            "key" : "MAIN_ROLE"
          }, {
            "description" : "Maintenance Manager or Supervisor",
            "key" : "FAM_MANAGER"
          }, {
            "description" : "Maintenance Supplier or Service",
            "key" : "FAM_SUPPLIER"
          }, {
            "description" : "Maintenance Worker",
            "key" : "FAM_WORKER"
          }, {
            "description" : "Manager",
            "key" : "MANAGER"
          }, {
            "description" : "Manufacturer",
            "key" : "MANUFACTURER"
          }, {
            "description" : "Not Applicable",
            "key" : "_NA_"
          }, {
            "description" : "Order Clerk",
            "key" : "ORDER_CLERK"
          }, {
            "description" : "Organization",
            "key" : "ORGANIZATION_ROLE"
          }, {
            "description" : "Organization Unit",
            "key" : "ORGANIZATION_UNIT"
          }, {
            "description" : "Originator",
            "key" : "ORIGINATOR"
          }, {
            "description" : "Other Internal",
            "key" : "OTHER_INTERNAL_ORGAN"
          }, {
            "description" : "Other Organization Unit",
            "key" : "OTHER_ORGANIZATION_U"
          }, {
            "description" : "Owner",
            "key" : "OWNER"
          }, {
            "description" : "Packer",
            "key" : "PACKER"
          }, {
            "description" : "Parent Organization",
            "key" : "PARENT_ORGANIZATION"
          }, {
            "description" : "Partner",
            "key" : "PARTNER"
          }, {
            "description" : "Person",
            "key" : "PERSON_ROLE"
          }, {
            "description" : "Picker",
            "key" : "PICKER"
          }, {
            "description" : "Placing Customer",
            "key" : "PLACING_CUSTOMER"
          }, {
            "description" : "Product Owner",
            "key" : "PRODUCT_OWNER"
          }, {
            "description" : "Product Owner Company",
            "key" : "PRODUCT_OWNER_COMP"
          }, {
            "description" : "Project Team",
            "key" : "PROJECT_TEAM"
          }, {
            "description" : "Prospect",
            "key" : "PROSPECT"
          }, {
            "description" : "Provider Accounting",
            "key" : "PROVIDER_ACCOUNTING"
          }, {
            "description" : "Provider Analyst",
            "key" : "PROVIDER_ANALYST"
          }, {
            "description" : "Provider Func. Impl",
            "key" : "PROVIDER_FUNCTIONAL"
          }, {
            "description" : "Provider Manager",
            "key" : "PROVIDER_MANAGER"
          }, {
            "description" : "Provider Tester",
            "key" : "PROVIDER_TESTER"
          }, {
            "description" : "Provider Validator",
            "key" : "PROVIDER_VALIDATOR"
          }, {
            "description" : "Receiver",
            "key" : "RECEIVER"
          }, {
            "description" : "Referrer",
            "key" : "REFERRER"
          }, {
            "description" : "Regulatory Agency",
            "key" : "REGULATORY_AGENCY"
          }, {
            "description" : "Request Manager",
            "key" : "REQ_MANAGER"
          }, {
            "description" : "Request Respondent",
            "key" : "REQ_RESPOND"
          }, {
            "description" : "Request Role",
            "key" : "REQUEST_ROLE"
          }, {
            "description" : "Request Taker",
            "key" : "REQ_TAKER"
          }, {
            "description" : "Requesting Party",
            "key" : "REQ_REQUESTER"
          }, {
            "description" : "Reviewer",
            "key" : "REVIEWER"
          }, {
            "description" : "SCRUM Master",
            "key" : "SCRUM_MASTER"
          }, {
            "description" : "SCRUM Team",
            "key" : "SCRUM_TEAM"
          }, {
            "description" : "Sales Force Autm.",
            "key" : "SFA_ROLE"
          }, {
            "description" : "Sales Representative",
            "key" : "SALES_REP"
          }, {
            "description" : "Scrum Member",
            "key" : "SCRUM_MEMBER"
          }, {
            "description" : "Shareholder",
            "key" : "SHAREHOLDER"
          }, {
            "description" : "Ship-From Vendor",
            "key" : "SHIP_FROM_VENDOR"
          }, {
            "description" : "Ship-To Customer",
            "key" : "SHIP_TO_CUSTOMER"
          }, {
            "description" : "Shipment Clerk",
            "key" : "SHIPMENT_CLERK"
          }, {
            "description" : "Sponsor",
            "key" : "SPONSOR"
          }, {
            "description" : "Spouse",
            "key" : "SPOUSE"
          }, {
            "description" : "Stakeholder",
            "key" : "STAKEHOLDER"
          }, {
            "description" : "Stocker",
            "key" : "STOCKER"
          }, {
            "description" : "Subscriber",
            "key" : "SUBSCRIBER"
          }, {
            "description" : "Subsidiary",
            "key" : "SUBSIDIARY"
          }, {
            "description" : "Supplier",
            "key" : "SUPPLIER"
          }, {
            "description" : "Supplier Agent",
            "key" : "SUPPLIER_AGENT"
          }, {
            "description" : "Tax Authority",
            "key" : "TAX_AUTHORITY"
          }, {
            "description" : "Union",
            "key" : "UNION"
          }, {
            "description" : "Vendor",
            "key" : "VENDOR"
          }, {
            "description" : "Visitor",
            "key" : "VISITOR"
          }, {
            "description" : "Web Master",
            "key" : "WEB_MASTER"
          }, {
            "description" : "Worker",
            "key" : "WORKER"
          }, {
            "description" : "Workflow",
            "key" : "WORKFLOW_ROLE"
          }, {
            "description" : "Workflow Owner",
            "key" : "WF_OWNER"
          } ],
          "disabled" : "false",
          "id" : "AddPartyToCategory_roleTypeId",
          "event" : "",
          "otherValue" : "",
          "fullSearch" : "",
          "fieldHelpText" : "",
          "dDFCurrent" : "selected",
          "tabindex" : "",
          "multiple" : "",
          "partialSearch" : "",
          "size" : "1",
          "name" : "roleTypeId",
          "style" : "",
          "explicitDescription" : "",
          "choices" : "",
          "currentValue" : ""
        }, {
          "classString" : "",
          "shortDateInput" : "false",
          "ampmName" : "",
          "className" : "",
          "title" : "From Date  Time",
          "type" : "DATE_TIME",
          "dateType" : "timestamp",
          "defaultDateTimeString" : "",
          "timeDropdown" : "text",
          "alert" : "false",
          "timeValues" : "",
          "formName" : "AddPartyToCategory",
          "timeDropdownParamName" : "fromDate",
          "timeMinutesName" : "",
          "disabled" : "false",
          "id" : "AddPartyToCategory_fromDate",
          "event" : "",
          "value" : "",
          "pmSelected" : "",
          "localizedInputTitle" : "Format: yyyy-MM-dd HH:mm:ss.SSS",
          "mask" : "",
          "hour1" : "0",
          "isTwelveHour" : "false",
          "fieldHelpText" : "",
          "hour2" : "0",
          "maxlength" : "30",
          "minutes" : "0",
          "tabindex" : "",
          "amSelected" : "",
          "size" : "25",
          "isXMLHttpRequest" : "false",
          "localizedIconTitle" : "View Calendar",
          "timeHourName" : "",
          "name" : "fromDate",
          "style" : "",
          "step" : "1",
          "compositeType" : ""
        }, {
          "buttonType" : "button",
          "alert" : "false",
          "formName" : "AddPartyToCategory",
          "tabindex" : "",
          "name" : "submitButton",
          "className" : "smallSubmit",
          "id" : "AddPartyToCategory_submitButton",
          "confirmation" : "",
          "type" : "SUBMIT",
          "title" : "Add",
          "event" : "",
          "imgSrc" : ""
        } ],
        "target" : "addPartyToCategory"
      },
      {
        "fieldSets" : [ {
          "fieldSetName" : "Default",
          "fields" : [ "parentProductCategoryId", "fromDate", "thruDate", "sequenceNum", "categoryName", "deleteLink", "submitButton" ]
        } ],
        "columns" : [ {
          "name" : "fromDate",
          "title" : "From Date"
        }, {
          "name" : "thruDate",
          "title" : "Through Date"
        }, {
          "name" : "sequenceNum",
          "title" : "Sequence"
        }, {
          "name" : "categoryName",
          "title" : "Parent Category [ID]"
        }, {
          "name" : "deleteLink",
          "title" : " "
        }, {
          "name" : "submitButton",
          "title" : "Update"
        } ],
        "formName" : "EditCategoryParentCategories",
        "altTarget" : [ ],
        "formLocation" : "component://kwikstore/widget/CategoryForms.xml",
        "fields" : [ {
          "conditionGroup" : "",
          "name" : "productCategoryId",
          "action" : "",
          "id" : "EditCategoryParentCategories_productCategoryId",
          "type" : "HIDDEN",
          "event" : "",
          "value" : ""
        }, {
          "conditionGroup" : "",
          "name" : "parentProductCategoryId",
          "action" : "",
          "id" : "EditCategoryParentCategories_parentProductCategoryId",
          "type" : "HIDDEN",
          "event" : "",
          "value" : ""
        }, {
          "fieldHelpText" : "",
          "ajaxEnabled" : false,
          "size" : 0,
          "name" : "fromDate",
          "description" : "",
          "style" : "",
          "id" : "EditCategoryParentCategories_fromDate",
          "title" : "",
          "type" : "DISPLAY",
          "imageLocation" : ""
        }, {
          "classString" : "",
          "shortDateInput" : "false",
          "ampmName" : "",
          "className" : "",
          "title" : "Through Date",
          "type" : "DATE_TIME",
          "dateType" : "timestamp",
          "defaultDateTimeString" : "2023-02-14%2016:20:18.453",
          "timeDropdown" : "",
          "alert" : "false",
          "timeValues" : "",
          "formName" : "EditCategoryParentCategories",
          "timeDropdownParamName" : "thruDate",
          "timeMinutesName" : "",
          "disabled" : "false",
          "id" : "EditCategoryParentCategories_thruDate",
          "event" : "",
          "value" : "",
          "pmSelected" : "",
          "localizedInputTitle" : "Format: yyyy-MM-dd HH:mm:ss.SSS",
          "mask" : "",
          "hour1" : "0",
          "isTwelveHour" : "false",
          "fieldHelpText" : "",
          "hour2" : "0",
          "maxlength" : "30",
          "minutes" : "0",
          "tabindex" : "",
          "amSelected" : "",
          "size" : "25",
          "isXMLHttpRequest" : "false",
          "localizedIconTitle" : "View Calendar",
          "timeHourName" : "",
          "name" : "thruDate",
          "style" : "",
          "step" : "1",
          "compositeType" : ""
        }, {
          "" : "",
          "fieldHelpText" : "",
          "textSize" : "6",
          "ajaxUrl" : "",
          "maxlength" : "",
          "tabindex" : "",
          "className" : "",
          "title" : "Sequence",
          "type" : "TEXT",
          "clientAutocomplete" : "true",
          "ajaxEnabled" : true,
          "readonly" : false,
          "alert" : "false",
          "name" : "sequenceNum",
          "action" : "",
          "style" : "",
          "disabled" : false,
          "id" : "EditCategoryParentCategories_sequenceNum",
          "placeholder" : "",
          "event" : "",
          "value" : "",
          "mask" : ""
        }, {
          "hyperlink" : {
            "linkStyle" : "buttontext",
            "description" : "[]",
            "targetType" : "intra-app",
            "confirmation" : "",
            "parameterMap" : {
              "VIEW_SIZE_0" : "20",
              "VIEW_INDEX_0" : "0"
            },
            "uniqueItemName" : "Modal_4c48aed3_326f_49e1_a3d6_c47720f76560",
            "target" : "EditProductCategory",
            "targetWindow" : "",
            "remoteFormData":{
                "formData":{
                    "formName":"EditProductCategory",
                    "formLocation":"component://kwikstore/widget/CategoryForms.xml",
                    "link":"/admin/categories/category/${productCategoryId}"
                }
            }
          },
          "event": "edit",
          "fieldHelpText" : "",
          "ajaxEnabled" : false,
          "size" : 0,
          "name" : "categoryName",
          "description" : "",
          "style" : "",
          "id" : "EditCategoryParentCategories_categoryName",
          "title" : "",
          "type" : "DISPLAY_ENTITY",
          "imageLocation" : ""
        }, {
          "image" : "",
          "width" : "",
          "name" : "deleteLink",
          "alternate" : "",
          "description" : "Delete",
          "parameterList" : [ {
            "name" : "parentProductCategoryId"
          }, {
            "name" : "productCategoryId"
          }, {
            "name" : "fromDate"
          } ],
          "id" : "EditCategoryParentCategories_deleteLink",
          "imageTitle" : "",
          "parameterMap" : { },
          "height" : ""
        }, {
          "buttonType" : "button",
          "alert" : "false",
          "formName" : "EditCategoryParentCategories",
          "tabindex" : "",
          "name" : "submitButton",
          "className" : "smallSubmit",
          "id" : "EditCategoryParentCategories_submitButton",
          "confirmation" : "",
          "type" : "SUBMIT",
          "title" : "Update",
          "event" : "",
          "imgSrc" : ""
        } ],
        "target" : "updateProductCategoryToCategory"
      },
      {
        "fieldSets" : [ {
          "fieldSetName" : "Default",
          "fields" : [ "parentProductCategoryId", "fromDate", "thruDate", "sequenceNum", "submitButton" ]
        } ],
        "formName" : "AddProductCategoryToCategory",
        "altTarget" : [ ],
        "targets":{
          createTarget:"addProductCategoryToCategory",
        },
        "formLocation" : "component://kwikstore/widget/CategoryForms.xml",
        "fields" : [ {
          "conditionGroup" : "",
          "name" : "productCategoryId",
          "action" : "",
          "id" : "AddProductCategoryToCategory_productCategoryId",
          "type" : "HIDDEN",
          "event" : "",
          "value" : ""
        }, {
          "fieldHelpText" : "",
          "lookupOptions" : {
            "ajaxUrl" : "",
            "fadeBackground" : "true",
            "conditionGroup" : "",
            "targetParameterList" : [ "" ],
            "className" : "required",
            "type" : "LOOKUP",
            "presentation" : "layer",
            "initiallyCollapsed" : "false",
            "ajaxEnabled" : "true",
            "showDescription" : "true",
            "delegatorName" : "",
            "readonly" : "false",
            "alert" : "false",
            "formName" : "AddProductCategoryToCategory",
            "id" : "AddProductCategoryToCategory_parentProductCategoryId",
            "event" : "",
            "value" : "",
            "fieldFormName" : "LookupPartyName",
            "maxlength" : "",
            "autocomplete" : "",
            "clearText" : "Clear",
            "tabindex" : "",
            "size" : "25",
            "name" : "parentProductCategoryId",
            "descriptionFieldName" : "",
            "position" : "topleft",
            "imgSrc" : ""
          },
          "name" : "parentProductCategoryId",
          "style" : "",
          "id" : "AddProductCategoryToCategory_parentProductCategoryId",
          "title" : "ParentProductCategoryId",
          "type" : "LOOKUP"
        }, {
          "classString" : "",
          "shortDateInput" : "false",
          "ampmName" : "",
          "className" : "",
          "title" : "From Date  Time",
          "type" : "DATE_TIME",
          "dateType" : "timestamp",
          "defaultDateTimeString" : "2023-02-14%2010:55:29.069",
          "timeDropdown" : "",
          "alert" : "false",
          "timeValues" : "",
          "formName" : "AddProductCategoryToCategory",
          "timeDropdownParamName" : "fromDate",
          "timeMinutesName" : "",
          "disabled" : "false",
          "id" : "AddProductCategoryToCategory_fromDate",
          "event" : "",
          "value" : "",
          "pmSelected" : "",
          "localizedInputTitle" : "Format: yyyy-MM-dd HH:mm:ss.SSS",
          "mask" : "",
          "hour1" : "0",
          "isTwelveHour" : "false",
          "fieldHelpText" : "",
          "hour2" : "0",
          "maxlength" : "30",
          "minutes" : "0",
          "tabindex" : "",
          "amSelected" : "",
          "size" : "25",
          "isXMLHttpRequest" : "false",
          "localizedIconTitle" : "View Calendar",
          "timeHourName" : "",
          "name" : "fromDate",
          "style" : "",
          "step" : "1",
          "compositeType" : ""
        }, {
          "classString" : "",
          "shortDateInput" : "false",
          "ampmName" : "",
          "className" : "",
          "title" : "Through Date",
          "type" : "DATE_TIME",
          "dateType" : "timestamp",
          "defaultDateTimeString" : "2023-02-14%2010:55:29.083",
          "timeDropdown" : "",
          "alert" : "false",
          "timeValues" : "",
          "formName" : "AddProductCategoryToCategory",
          "timeDropdownParamName" : "thruDate",
          "timeMinutesName" : "",
          "disabled" : "false",
          "id" : "AddProductCategoryToCategory_thruDate",
          "event" : "",
          "value" : "",
          "pmSelected" : "",
          "localizedInputTitle" : "Format: yyyy-MM-dd HH:mm:ss.SSS",
          "mask" : "",
          "hour1" : "0",
          "isTwelveHour" : "false",
          "fieldHelpText" : "",
          "hour2" : "0",
          "maxlength" : "30",
          "minutes" : "0",
          "tabindex" : "",
          "amSelected" : "",
          "size" : "25",
          "isXMLHttpRequest" : "false",
          "localizedIconTitle" : "View Calendar",
          "timeHourName" : "",
          "name" : "thruDate",
          "style" : "",
          "step" : "1",
          "compositeType" : ""
        }, {
          "" : "",
          "fieldHelpText" : "",
          "textSize" : "6",
          "ajaxUrl" : "",
          "maxlength" : "",
          "tabindex" : "",
          "className" : "",
          "title" : "Sequence Num",
          "type" : "TEXT",
          "clientAutocomplete" : "true",
          "ajaxEnabled" : true,
          "readonly" : false,
          "alert" : "false",
          "name" : "sequenceNum",
          "action" : "",
          "style" : "",
          "disabled" : false,
          "id" : "AddProductCategoryToCategory_sequenceNum",
          "placeholder" : "",
          "event" : "",
          "value" : "",
          "mask" : ""
        }, {
          "buttonType" : "button",
          "alert" : "false",
          "formName" : "AddProductCategoryToCategory",
          "tabindex" : "",
          "name" : "submitButton",
          "className" : "smallSubmit",
          "id" : "AddProductCategoryToCategory_submitButton",
          "confirmation" : "",
          "type" : "SUBMIT",
          "title" : "Add",
          "event" : "",
          "imgSrc" : ""
        } ],
        "target" : "addProductCategoryToCategory"
      },
      {
        "fieldSets" : [ {
          "fieldSetName" : "Default",
          "fields" : [ "parentProductCategoryId", "fromDate", "thruDate", "sequenceNum", "categoryName", "deleteLink", "submitButton" ]
        } ],
        "columns" : [ {
          "name" : "fromDate",
          "title" : "From Date"
        }, {
          "name" : "thruDate",
          "title" : "Through Date"
        }, {
          "name" : "sequenceNum",
          "title" : "Sequence"
        }, {
          "name" : "categoryName",
          "title" : "Child Category ID"
        }, {
          "name" : "deleteLink",
          "title" : " "
        }, {
          "name" : "submitButton",
          "title" : "Update"
        } ],
        "formName" : "EditCategoryChildCategories",
        "altTarget" : [ ],
        "formLocation" : "component://kwikstore/widget/CategoryForms.xml",
        "fields" : [ {
          "conditionGroup" : "",
          "name" : "productCategoryId",
          "action" : "",
          "id" : "EditCategoryChildCategories_productCategoryId",
          "type" : "HIDDEN",
          "event" : "",
          "value" : ""
        }, {
          "conditionGroup" : "",
          "name" : "parentProductCategoryId",
          "action" : "",
          "id" : "EditCategoryChildCategories_parentProductCategoryId",
          "type" : "HIDDEN",
          "event" : "",
          "value" : ""
        }, {
          "fieldHelpText" : "",
          "ajaxEnabled" : false,
          "size" : 0,
          "name" : "fromDate",
          "description" : "",
          "style" : "",
          "id" : "EditCategoryChildCategories_fromDate",
          "title" : "",
          "type" : "DISPLAY",
          "imageLocation" : ""
        }, {
          "classString" : "",
          "shortDateInput" : "false",
          "ampmName" : "",
          "className" : "",
          "title" : "Through Date",
          "type" : "DATE_TIME",
          "dateType" : "timestamp",
          "defaultDateTimeString" : "2023-02-14%2016:28:13.03",
          "timeDropdown" : "",
          "alert" : "false",
          "timeValues" : "",
          "formName" : "EditCategoryChildCategories",
          "timeDropdownParamName" : "thruDate",
          "timeMinutesName" : "",
          "disabled" : "false",
          "id" : "EditCategoryChildCategories_thruDate",
          "event" : "",
          "value" : "",
          "pmSelected" : "",
          "localizedInputTitle" : "Format: yyyy-MM-dd HH:mm:ss.SSS",
          "mask" : "",
          "hour1" : "0",
          "isTwelveHour" : "false",
          "fieldHelpText" : "",
          "hour2" : "0",
          "maxlength" : "30",
          "minutes" : "0",
          "tabindex" : "",
          "amSelected" : "",
          "size" : "25",
          "isXMLHttpRequest" : "false",
          "localizedIconTitle" : "View Calendar",
          "timeHourName" : "",
          "name" : "thruDate",
          "style" : "",
          "step" : "1",
          "compositeType" : ""
        }, {
          "" : "",
          "fieldHelpText" : "",
          "textSize" : "6",
          "ajaxUrl" : "",
          "maxlength" : "",
          "tabindex" : "",
          "className" : "",
          "title" : "Sequence",
          "type" : "TEXT",
          "clientAutocomplete" : "true",
          "ajaxEnabled" : true,
          "readonly" : false,
          "alert" : "false",
          "name" : "sequenceNum",
          "action" : "",
          "style" : "",
          "disabled" : false,
          "id" : "EditCategoryChildCategories_sequenceNum",
          "placeholder" : "",
          "event" : "",
          "value" : "",
          "mask" : ""
        }, {
          "hyperlink" : {
            "linkStyle" : "buttontext",
            "description" : "[]",
            "targetType" : "intra-app",
            "confirmation" : "",
            "parameterMap" : {
              "VIEW_SIZE_0" : "20",
              "VIEW_INDEX_0" : "0"
            },
            "uniqueItemName" : "Modal_0c388538_e291_4261_95e0_19933bf18766",
            "target" : "EditProductCategory",
            "targetWindow" : "",
            "remoteFormData":{
                "formData":{
                    "formName":"EditProductCategory",
                    "formLocation":"component://kwikstore/widget/CategoryForms.xml",
                    "link":"/admin/categories/category/${productCategoryId}"
                }
            },
          },
          "event" : "edit",
          "fieldHelpText" : "",
          "ajaxEnabled" : false,
          "size" : 0,
          "name" : "categoryName",
          "description" : "",
          "style" : "",
          "id" : "EditCategoryChildCategories_categoryName",
          "title" : "",
          "type" : "DISPLAY_ENTITY",
          "imageLocation" : ""
        }, {
          "image" : "",
          "width" : "",
          "name" : "deleteLink",
          "alternate" : "",
          "description" : "Delete",
          "parameterList" : [ {
            "name" : "parentProductCategoryId"
          }, {
            "name" : "productCategoryId"
          }, {
            "name" : "fromDate"
          } ],
          "id" : "EditCategoryChildCategories_deleteLink",
          "imageTitle" : "",
          "parameterMap" : { },
          "height" : ""
        }, {
          "buttonType" : "button",
          "alert" : "false",
          "formName" : "EditCategoryChildCategories",
          "tabindex" : "",
          "name" : "submitButton",
          "className" : "smallSubmit",
          "id" : "EditCategoryChildCategories_submitButton",
          "confirmation" : "",
          "type" : "SUBMIT",
          "title" : "Update",
          "event" : "",
          "imgSrc" : ""
        } ],
        "target" : "updateProductCategoryToCategory"
      },
      {
        "fieldSets" : [ {
          "fieldSetName" : "Default",
          "fields" : [ "parentProductCategoryId", "fromDate", "thruDate", "sequenceNum", "submitButton" ]
        } ],
        "formName" : "AddChildCategoryToCategory",
        "altTarget" : [ ],
        "targets":{
          createTarget:"addProductCategoryToCategory",
        },
        "formLocation" : "component://kwikstore/widget/CategoryForms.xml",
        "fields" : [ {
          "conditionGroup" : "",
          "name" : "parentProductCategoryId",
          "action" : "",
          "id" : "AddChildCategoryToCategory_parentProductCategoryId",
          "type" : "HIDDEN",
          "event" : "",
          "value" : ""
        }, {
          "fieldHelpText" : "",
          "lookupOptions" : {
            "ajaxUrl" : "",
            "fadeBackground" : "true",
            "conditionGroup" : "",
            "targetParameterList" : [ "" ],
            "className" : "required",
            "type" : "LOOKUP",
            "presentation" : "layer",
            "initiallyCollapsed" : "false",
            "ajaxEnabled" : "true",
            "showDescription" : "true",
            "delegatorName" : "",
            "readonly" : "false",
            "alert" : "false",
            "formName" : "AddChildCategoryToCategory",
            "id" : "AddChildCategoryToCategory_productCategoryId",
            "event" : "",
            "value" : "",
            "fieldFormName" : "LookupPartyName",
            "maxlength" : "",
            "autocomplete" : "",
            "clearText" : "Clear",
            "tabindex" : "",
            "size" : "25",
            "name" : "productCategoryId",
            "descriptionFieldName" : "",
            "position" : "topleft",
            "imgSrc" : ""
          },
          "name" : "productCategoryId",
          "style" : "",
          "id" : "AddChildCategoryToCategory_productCategoryId",
          "title" : "Category ID",
          "type" : "LOOKUP"
        }, {
          "classString" : "",
          "shortDateInput" : "false",
          "ampmName" : "",
          "className" : "",
          "title" : "From Date  Time",
          "type" : "DATE_TIME",
          "dateType" : "timestamp",
          "defaultDateTimeString" : "2023-02-14%2016:29:50.188",
          "timeDropdown" : "",
          "alert" : "false",
          "timeValues" : "",
          "formName" : "AddChildCategoryToCategory",
          "timeDropdownParamName" : "fromDate",
          "timeMinutesName" : "",
          "disabled" : "false",
          "id" : "AddChildCategoryToCategory_fromDate",
          "event" : "",
          "value" : "",
          "pmSelected" : "",
          "localizedInputTitle" : "Format: yyyy-MM-dd HH:mm:ss.SSS",
          "mask" : "",
          "hour1" : "0",
          "isTwelveHour" : "false",
          "fieldHelpText" : "",
          "hour2" : "0",
          "maxlength" : "30",
          "minutes" : "0",
          "tabindex" : "",
          "amSelected" : "",
          "size" : "25",
          "isXMLHttpRequest" : "false",
          "localizedIconTitle" : "View Calendar",
          "timeHourName" : "",
          "name" : "fromDate",
          "style" : "",
          "step" : "1",
          "compositeType" : ""
        }, {
          "classString" : "",
          "shortDateInput" : "false",
          "ampmName" : "",
          "className" : "",
          "title" : "Through Date",
          "type" : "DATE_TIME",
          "dateType" : "timestamp",
          "defaultDateTimeString" : "2023-02-14%2016:29:50.188",
          "timeDropdown" : "",
          "alert" : "false",
          "timeValues" : "",
          "formName" : "AddChildCategoryToCategory",
          "timeDropdownParamName" : "thruDate",
          "timeMinutesName" : "",
          "disabled" : "false",
          "id" : "AddChildCategoryToCategory_thruDate",
          "event" : "",
          "value" : "",
          "pmSelected" : "",
          "localizedInputTitle" : "Format: yyyy-MM-dd HH:mm:ss.SSS",
          "mask" : "",
          "hour1" : "0",
          "isTwelveHour" : "false",
          "fieldHelpText" : "",
          "hour2" : "0",
          "maxlength" : "30",
          "minutes" : "0",
          "tabindex" : "",
          "amSelected" : "",
          "size" : "25",
          "isXMLHttpRequest" : "false",
          "localizedIconTitle" : "View Calendar",
          "timeHourName" : "",
          "name" : "thruDate",
          "style" : "",
          "step" : "1",
          "compositeType" : ""
        }, {
          "" : "",
          "fieldHelpText" : "",
          "textSize" : "6",
          "ajaxUrl" : "",
          "maxlength" : "",
          "tabindex" : "",
          "className" : "",
          "title" : "Sequence Num",
          "type" : "TEXT",
          "clientAutocomplete" : "true",
          "ajaxEnabled" : true,
          "readonly" : false,
          "alert" : "false",
          "name" : "sequenceNum",
          "action" : "",
          "style" : "",
          "disabled" : false,
          "id" : "AddChildCategoryToCategory_sequenceNum",
          "placeholder" : "",
          "event" : "",
          "value" : "",
          "mask" : ""
        }, {
          "buttonType" : "button",
          "alert" : "false",
          "formName" : "AddChildCategoryToCategory",
          "tabindex" : "",
          "name" : "submitButton",
          "className" : "smallSubmit",
          "id" : "AddChildCategoryToCategory_submitButton",
          "confirmation" : "",
          "type" : "SUBMIT",
          "title" : "Add",
          "event" : "",
          "imgSrc" : ""
        } ],
        "target" : "addProductCategoryToCategory"
      },
      {
        "fieldSets" : [ {
          "fieldSetName" : "Default",
          "fields" : [ "productFeatureGroupId", "fromDate", "thruDate", "deleteLink", "submitButton" ]
        } ],
        "columns" : [ {
          "name" : "productFeatureGroupId",
          "title" : "Feature Group"
        }, {
          "name" : "fromDate",
          "title" : "From Date  Time"
        }, {
          "name" : "thruDate",
          "title" : "Through Date"
        }, {
          "name" : "deleteLink",
          "title" : " "
        }, {
          "name" : "submitButton",
          "title" : "Update"
        } ],
        "formName" : "EditCategoryFeatureGroupFeature",
        "altTarget" : [ ],
        "formLocation" : "component://kwikstore/widget/CategoryForms.xml",
        "fields" : [ {
          "conditionGroup" : "",
          "name" : "productCategoryId",
          "action" : "",
          "id" : "EditCategoryFeatureGroupFeature_productCategoryId",
          "type" : "HIDDEN",
          "event" : "",
          "value" : ""
        }, {
          "hyperlink" : {
            "linkStyle" : "buttontext",
            "description" : "[]",
            "targetType" : "intra-app",
            "confirmation" : "",
            "parameterMap" : {
              "VIEW_SIZE_0" : "20",
              "VIEW_INDEX_0" : "0"
            },
            "uniqueItemName" : "Modal_94bad4ea_561f_418c_9528_a50ac97dc7d9",
            "target" : "EditFeatureGroupAppls",
            "targetWindow" : "",
            "remoteFormData":{
                "formData":{
                    "formName":"EditFeatureGroupAppls",
                    "formLocation":"component://kwikstore/widget/CategoryForms.xml",
                    "link":"/admin/categories/category/${productCategoryId}"
                }
            },
          },
          "event":"edit",
          "fieldHelpText" : "",
          "ajaxEnabled" : false,
          "size" : 0,
          "name" : "productFeatureGroupId",
          "description" : "",
          "style" : "",
          "id" : "EditCategoryFeatureGroupFeature_productFeatureGroupId",
          "title" : "",
          "type" : "DISPLAY_ENTITY",
          "imageLocation" : ""
        }, {
          "classString" : "",
          "shortDateInput" : "false",
          "ampmName" : "",
          "className" : "",
          "title" : "From Date  Time",
          "type" : "DATE_TIME",
          "dateType" : "timestamp",
          "defaultDateTimeString" : "2023-02-15%2013:39:51.068",
          "timeDropdown" : "",
          "alert" : "false",
          "timeValues" : "",
          "formName" : "EditCategoryFeatureGroupFeature",
          "timeDropdownParamName" : "fromDate",
          "timeMinutesName" : "",
          "disabled" : "false",
          "id" : "EditCategoryFeatureGroupFeature_fromDate",
          "event" : "",
          "value" : "",
          "pmSelected" : "",
          "localizedInputTitle" : "Format: yyyy-MM-dd HH:mm:ss.SSS",
          "mask" : "",
          "hour1" : "0",
          "isTwelveHour" : "false",
          "fieldHelpText" : "",
          "hour2" : "0",
          "maxlength" : "30",
          "minutes" : "0",
          "tabindex" : "",
          "amSelected" : "",
          "size" : "25",
          "isXMLHttpRequest" : "false",
          "localizedIconTitle" : "View Calendar",
          "timeHourName" : "",
          "name" : "fromDate",
          "style" : "",
          "step" : "1",
          "compositeType" : ""
        }, {
          "classString" : "",
          "shortDateInput" : "false",
          "ampmName" : "",
          "className" : "",
          "title" : "Through Date",
          "type" : "DATE_TIME",
          "dateType" : "timestamp",
          "defaultDateTimeString" : "2023-02-15%2013:39:51.068",
          "timeDropdown" : "",
          "alert" : "false",
          "timeValues" : "",
          "formName" : "EditCategoryFeatureGroupFeature",
          "timeDropdownParamName" : "thruDate",
          "timeMinutesName" : "",
          "disabled" : "false",
          "id" : "EditCategoryFeatureGroupFeature_thruDate",
          "event" : "",
          "value" : "",
          "pmSelected" : "",
          "localizedInputTitle" : "Format: yyyy-MM-dd HH:mm:ss.SSS",
          "mask" : "",
          "hour1" : "0",
          "isTwelveHour" : "false",
          "fieldHelpText" : "",
          "hour2" : "0",
          "maxlength" : "30",
          "minutes" : "0",
          "tabindex" : "",
          "amSelected" : "",
          "size" : "25",
          "isXMLHttpRequest" : "false",
          "localizedIconTitle" : "View Calendar",
          "timeHourName" : "",
          "name" : "thruDate",
          "style" : "",
          "step" : "1",
          "compositeType" : ""
        }, {
          "image" : "",
          "width" : "",
          "name" : "deleteLink",
          "alternate" : "",
          "description" : "Delete",
          "parameterList" : [ {
            "name" : "parentProductCategoryId"
          }, {
            "name" : "productCategoryId"
          }, {
            "name" : "fromDate"
          } ],
          "id" : "EditCategoryFeatureGroupFeature_deleteLink",
          "imageTitle" : "",
          "parameterMap" : { },
          "height" : ""
        }, {
          "buttonType" : "button",
          "alert" : "false",
          "formName" : "EditCategoryFeatureGroupFeature",
          "tabindex" : "",
          "name" : "submitButton",
          "className" : "smallSubmit",
          "id" : "EditCategoryFeatureGroupFeature_submitButton",
          "confirmation" : "",
          "type" : "SUBMIT",
          "title" : "Update",
          "event" : "",
          "imgSrc" : ""
        } ],
        "target" : "updateProductFeatureCatGrpAppl"
      },
      {
        "fieldSets" : [ {
          "fieldSetName" : "Default",
          "fields" : [ "productFeatureGroupId", "fromDate", "thruDate", "submitButton" ]
        } ],
        "formName" : "AddFeatureGroupToCategory",
        "targets":{
          "createTarget":"createProductFeatureCatGrpAppl"
        },
        "altTarget" : [ ],
        "formLocation" : "component://kwikstore/widget/CategoryForms.xml",
        "fields" : [ {
          "" : "",
          "fieldHelpText" : "",
          "textSize" : "20",
          "ajaxUrl" : "",
          "maxlength" : "20",
          "tabindex" : "",
          "className" : "required",
          "title" : "Product Category ID",
          "type" : "TEXT",
          "clientAutocomplete" : "true",
          "ajaxEnabled" : true,
          "readonly" : false,
          "alert" : "false",
          "name" : "productCategoryId",
          "action" : "",
          "style" : "",
          "disabled" : false,
          "id" : "AddFeatureGroupToCategory_productCategoryId",
          "placeholder" : "",
          "event" : "",
          "value" : "",
          "mask" : ""
        }, {
          "fieldName" : "",
          "firstInList" : "",
          "partialChars" : "",
          "conditionGroup" : "",
          "otherFieldName" : "",
          "className" : "",
          "title" : "ProductFeatureGroupId",
          "type" : "DROP_DOWN",
          "frequency" : "",
          "minChars" : "",
          "allowEmpty" : "",
          "autoSelect" : "",
          "ajaxEnabled" : "false",
          "noCurrentSelectedKey" : "",
          "ajaxOptions" : "",
          "alert" : "false",
          "otherFieldSize" : "0",
          "ignoreCase" : "",
          "formName" : "AddFeatureGroupToCategory",
          "options" : [ {
            "description" : "Test Feature Group",
            "key" : "10000"
          } ],
          "disabled" : "false",
          "id" : "AddFeatureGroupToCategory_productFeatureGroupId",
          "event" : "",
          "otherValue" : "",
          "fullSearch" : "",
          "fieldHelpText" : "",
          "dDFCurrent" : "selected",
          "tabindex" : "",
          "multiple" : "",
          "partialSearch" : "",
          "size" : "1",
          "name" : "productFeatureGroupId",
          "style" : "",
          "explicitDescription" : "",
          "choices" : "",
          "currentValue" : ""
        }, {
          "classString" : "",
          "shortDateInput" : "false",
          "ampmName" : "",
          "className" : "",
          "title" : "From Date  Time",
          "type" : "DATE_TIME",
          "dateType" : "timestamp",
          "defaultDateTimeString" : "2023-02-15%2013:43:12.972",
          "timeDropdown" : "",
          "alert" : "false",
          "timeValues" : "",
          "formName" : "AddFeatureGroupToCategory",
          "timeDropdownParamName" : "fromDate",
          "timeMinutesName" : "",
          "disabled" : "false",
          "id" : "AddFeatureGroupToCategory_fromDate",
          "event" : "",
          "value" : "",
          "pmSelected" : "",
          "localizedInputTitle" : "Format: yyyy-MM-dd HH:mm:ss.SSS",
          "mask" : "",
          "hour1" : "0",
          "isTwelveHour" : "false",
          "fieldHelpText" : "",
          "hour2" : "0",
          "maxlength" : "30",
          "minutes" : "0",
          "tabindex" : "",
          "amSelected" : "",
          "size" : "25",
          "isXMLHttpRequest" : "false",
          "localizedIconTitle" : "View Calendar",
          "timeHourName" : "",
          "name" : "fromDate",
          "style" : "",
          "step" : "1",
          "compositeType" : ""
        }, {
          "classString" : "",
          "shortDateInput" : "false",
          "ampmName" : "",
          "className" : "",
          "title" : "Through Date",
          "type" : "DATE_TIME",
          "dateType" : "timestamp",
          "defaultDateTimeString" : "2023-02-15%2013:43:12.972",
          "timeDropdown" : "",
          "alert" : "false",
          "timeValues" : "",
          "formName" : "AddFeatureGroupToCategory",
          "timeDropdownParamName" : "thruDate",
          "timeMinutesName" : "",
          "disabled" : "false",
          "id" : "AddFeatureGroupToCategory_thruDate",
          "event" : "",
          "value" : "",
          "pmSelected" : "",
          "localizedInputTitle" : "Format: yyyy-MM-dd HH:mm:ss.SSS",
          "mask" : "",
          "hour1" : "0",
          "isTwelveHour" : "false",
          "fieldHelpText" : "",
          "hour2" : "0",
          "maxlength" : "30",
          "minutes" : "0",
          "tabindex" : "",
          "amSelected" : "",
          "size" : "25",
          "isXMLHttpRequest" : "false",
          "localizedIconTitle" : "View Calendar",
          "timeHourName" : "",
          "name" : "thruDate",
          "style" : "",
          "step" : "1",
          "compositeType" : ""
        }, {
          "buttonType" : "button",
          "alert" : "false",
          "formName" : "AddFeatureGroupToCategory",
          "tabindex" : "",
          "name" : "submitButton",
          "className" : "smallSubmit",
          "id" : "AddFeatureGroupToCategory_submitButton",
          "confirmation" : "",
          "type" : "SUBMIT",
          "title" : "Add",
          "event" : "",
          "imgSrc" : ""
        } ],
        "target" : "createProductFeatureCatGrpAppl"
      },
      {
        "fieldSets" : [ {
          "fieldSetName" : "Default",
          "fields" : [ "productFeatureCategoryId", "fromDate", "thruDate", "deleteLink", "submitButton" ]
        } ],
        "columns" : [ {
          "name" : "productFeatureCategoryId",
          "title" : "Feature Category"
        }, {
          "name" : "fromDate",
          "title" : "From Date"
        }, {
          "name" : "thruDate",
          "title" : "Through Date"
        }, {
          "name" : "deleteLink",
          "title" : " "
        }, {
          "name" : "submitButton",
          "title" : "Update"
        } ],
        "formName" : "EditCategoryFeatureCategoryFeature",
        "altTarget" : [ ],
        "formLocation" : "component://kwikstore/widget/CategoryForms.xml",
        "fields" : [ {
          "conditionGroup" : "",
          "name" : "productCategoryId",
          "action" : "",
          "id" : "EditCategoryFeatureCategoryFeature_productCategoryId",
          "type" : "HIDDEN",
          "event" : "",
          "value" : ""
        }, {
          "hyperlink" : {
            "linkStyle" : "buttontext",
            "description" : "[]",
            "targetType" : "intra-app",
            "confirmation" : "",
            "parameterMap" : {
              "VIEW_SIZE_0" : "20",
              "VIEW_INDEX_0" : "0"
            },
            "uniqueItemName" : "Modal_c1cbfae5_8447_4ec4_834b_e0db4e9a28ae",
            "target" : "EditFeatureCategoryFeatures",
            "targetWindow" : "",
            "remoteFormData":{
                "formData":{
                    "formName":"EditFeatureCategoryFeatures",
                    "formLocation":"component://kwikstore/widget/CategoryForms.xml",
                    "link":"/admin/categories/category/${productCategoryId}"
                }
            }
          },
          "event" :  "edit",
          "fieldHelpText" : "",
          "ajaxEnabled" : false,
          "size" : 0,
          "name" : "productFeatureCategoryId",
          "description" : "",
          "style" : "",
          "id" : "EditCategoryFeatureCategoryFeature_productFeatureCategoryId",
          "title" : "",
          "type" : "DISPLAY_ENTITY",
          "imageLocation" : ""
        }, {
          "fieldHelpText" : "",
          "ajaxEnabled" : false,
          "size" : 0,
          "name" : "fromDate",
          "description" : "",
          "style" : "",
          "id" : "EditCategoryFeatureCategoryFeature_fromDate",
          "title" : "",
          "type" : "DISPLAY",
          "imageLocation" : ""
        }, {
          "classString" : "",
          "shortDateInput" : "false",
          "ampmName" : "",
          "className" : "",
          "title" : "Through Date",
          "type" : "DATE_TIME",
          "dateType" : "timestamp",
          "defaultDateTimeString" : "2023-02-15%2015:09:47.794",
          "timeDropdown" : "text",
          "alert" : "false",
          "timeValues" : "",
          "formName" : "EditCategoryFeatureCategoryFeature",
          "timeDropdownParamName" : "thruDate",
          "timeMinutesName" : "",
          "disabled" : "false",
          "id" : "EditCategoryFeatureCategoryFeature_thruDate",
          "event" : "",
          "value" : "",
          "pmSelected" : "",
          "localizedInputTitle" : "Format: yyyy-MM-dd HH:mm:ss.SSS",
          "mask" : "",
          "hour1" : "0",
          "isTwelveHour" : "false",
          "fieldHelpText" : "",
          "hour2" : "0",
          "maxlength" : "30",
          "minutes" : "0",
          "tabindex" : "",
          "amSelected" : "",
          "size" : "25",
          "isXMLHttpRequest" : "false",
          "localizedIconTitle" : "View Calendar",
          "timeHourName" : "",
          "name" : "thruDate",
          "style" : "",
          "step" : "1",
          "compositeType" : ""
        }, {
          "image" : "",
          "width" : "",
          "name" : "deleteLink",
          "alternate" : "",
          "description" : "Delete",
          "parameterList" : [ {
            "name" : "productFeatureCategoryId"
          }, {
            "name" : "productCategoryId"
          }, {
            "name" : "fromDate"
          } ],
          "id" : "EditCategoryFeatureCategoryFeature_deleteLink",
          "imageTitle" : "",
          "parameterMap" : { },
          "height" : ""
        }, {
          "buttonType" : "button",
          "alert" : "false",
          "formName" : "EditCategoryFeatureCategoryFeature",
          "tabindex" : "",
          "name" : "submitButton",
          "className" : "smallSubmit",
          "id" : "EditCategoryFeatureCategoryFeature_submitButton",
          "confirmation" : "",
          "type" : "SUBMIT",
          "title" : "Update",
          "event" : "",
          "imgSrc" : ""
        } ],
        "target" : "updateProductFeatureCategoryAppl"
      },
      {
        "fieldSets" : [ {
          "fieldSetName" : "Default",
          "fields" : [ "productFeatureCategoryId", "fromDate", "thruDate", "submitButton" ]
        } ],
        "formName" : "AddFeatureCategoryToCategory",
        "targets":{
          "createTarget":"createProductFeatureCategoryAppl"
        },
        "altTarget" : [ ],
        "formLocation" : "component://kwikstore/widget/CategoryForms.xml",
        "fields" : [ {
          "conditionGroup" : "",
          "name" : "productCategoryId",
          "action" : "",
          "id" : "AddFeatureCategoryToCategory_productCategoryId",
          "type" : "HIDDEN",
          "event" : "",
          "value" : ""
        }, {
          "fieldName" : "",
          "firstInList" : "",
          "partialChars" : "",
          "conditionGroup" : "",
          "otherFieldName" : "",
          "className" : "",
          "title" : "Feature Category",
          "type" : "DROP_DOWN",
          "frequency" : "",
          "minChars" : "",
          "allowEmpty" : "",
          "autoSelect" : "",
          "ajaxEnabled" : "false",
          "noCurrentSelectedKey" : "",
          "ajaxOptions" : "",
          "alert" : "false",
          "otherFieldSize" : "0",
          "ignoreCase" : "",
          "formName" : "AddFeatureCategoryToCategory",
          "options" : [ {
            "description" : "Account Features",
            "key" : "2100"
          }, {
            "description" : "Equipment Class Features",
            "key" : "1002"
          }, {
            "description" : "Gift Card Features",
            "key" : "2000"
          }, {
            "description" : "Hazmat Features",
            "key" : "1000"
          }, {
            "description" : "Image",
            "key" : "IMAGE"
          }, {
            "description" : "License Features",
            "key" : "8000"
          }, {
            "description" : "Model Year Features",
            "key" : "1001"
          }, {
            "description" : "Scanning Type",
            "key" : "SCAN_TYPE"
          }, {
            "description" : "Taste",
            "key" : "3000"
          }, {
            "description" : "Text",
            "key" : "TEXT"
          }, {
            "description" : "Widget Features",
            "key" : "9000"
          } ],
          "disabled" : "false",
          "id" : "AddFeatureCategoryToCategory_productFeatureCategoryId",
          "event" : "",
          "otherValue" : "",
          "fullSearch" : "",
          "fieldHelpText" : "",
          "dDFCurrent" : "selected",
          "tabindex" : "",
          "multiple" : "",
          "partialSearch" : "",
          "size" : "1",
          "name" : "productFeatureCategoryId",
          "style" : "",
          "explicitDescription" : "",
          "choices" : "",
          "currentValue" : ""
        }, {
          "classString" : "",
          "shortDateInput" : "false",
          "ampmName" : "",
          "className" : "",
          "title" : "From Date  Time",
          "type" : "DATE_TIME",
          "dateType" : "timestamp",
          "defaultDateTimeString" : "2023-02-15%2015:53:00.7",
          "timeDropdown" : "text",
          "alert" : "false",
          "timeValues" : "",
          "formName" : "AddFeatureCategoryToCategory",
          "timeDropdownParamName" : "fromDate",
          "timeMinutesName" : "",
          "disabled" : "false",
          "id" : "AddFeatureCategoryToCategory_fromDate",
          "event" : "",
          "value" : "",
          "pmSelected" : "",
          "localizedInputTitle" : "Format: yyyy-MM-dd HH:mm:ss.SSS",
          "mask" : "",
          "hour1" : "0",
          "isTwelveHour" : "false",
          "fieldHelpText" : "",
          "hour2" : "0",
          "maxlength" : "30",
          "minutes" : "0",
          "tabindex" : "",
          "amSelected" : "",
          "size" : "25",
          "isXMLHttpRequest" : "false",
          "localizedIconTitle" : "View Calendar",
          "timeHourName" : "",
          "name" : "fromDate",
          "style" : "",
          "step" : "1",
          "compositeType" : ""
        }, {
          "classString" : "",
          "shortDateInput" : "false",
          "ampmName" : "",
          "className" : "",
          "title" : "Through Date",
          "type" : "DATE_TIME",
          "dateType" : "timestamp",
          "defaultDateTimeString" : "2023-02-15%2015:53:00.703",
          "timeDropdown" : "",
          "alert" : "false",
          "timeValues" : "",
          "formName" : "AddFeatureCategoryToCategory",
          "timeDropdownParamName" : "thruDate",
          "timeMinutesName" : "",
          "disabled" : "false",
          "id" : "AddFeatureCategoryToCategory_thruDate",
          "event" : "",
          "value" : "",
          "pmSelected" : "",
          "localizedInputTitle" : "Format: yyyy-MM-dd HH:mm:ss.SSS",
          "mask" : "",
          "hour1" : "0",
          "isTwelveHour" : "false",
          "fieldHelpText" : "",
          "hour2" : "0",
          "maxlength" : "30",
          "minutes" : "0",
          "tabindex" : "",
          "amSelected" : "",
          "size" : "25",
          "isXMLHttpRequest" : "false",
          "localizedIconTitle" : "View Calendar",
          "timeHourName" : "",
          "name" : "thruDate",
          "style" : "",
          "step" : "1",
          "compositeType" : ""
        }, {
          "buttonType" : "button",
          "alert" : "false",
          "formName" : "AddFeatureCategoryToCategory",
          "tabindex" : "",
          "name" : "submitButton",
          "className" : "smallSubmit",
          "id" : "AddFeatureCategoryToCategory_submitButton",
          "confirmation" : "",
          "type" : "SUBMIT",
          "title" : "Add",
          "event" : "",
          "imgSrc" : ""
        } ],
        "target" : "createProductFeatureCategoryAppl"
      }




      
      
]